export default function ResumeIconsSprite() {
  return (
    <svg
      viewBox="0 0 150 150"
      fill="none"
      id="logos-sprite"
      xmlns="http://www.w3.org/2000/svg"
      width="0"
      height="0"
    >
      <defs>
        <symbol id="symb-psd" viewBox="0 0 150 150">
          <defs>
            <clipPath id="psd-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="PSD">
            <g clipPath="url(#psd-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#001e36"
                />
                <path
                  d="M33.75,104.32V40.01c0-.44.19-.69.63-.69,1.06,0,2.06,0,3.5-.06,1.5-.06,3.06-.06,4.75-.12,1.69-.06,3.5-.06,5.44-.13,1.94-.06,3.81-.06,5.69-.06,5.13,0,9.37.62,12.88,1.94,3.14,1.07,6,2.82,8.37,5.13,2.01,2.02,3.57,4.45,4.56,7.13.94,2.62,1.44,5.31,1.44,8.13,0,5.37-1.25,9.81-3.75,13.31-2.5,3.5-6,6.12-10.06,7.62-4.25,1.56-8.94,2.13-14.06,2.13-1.5,0-2.5,0-3.13-.06-.63-.06-1.5-.06-2.69-.06v20.06c.06.44-.25.81-.69.88h-12.12c-.5,0-.75-.25-.75-.81ZM47.37,51.38v21c.88.06,1.69.13,2.44.13h3.31c2.44,0,4.87-.38,7.19-1.13,2-.56,3.75-1.75,5.13-3.31,1.31-1.56,1.94-3.69,1.94-6.44.06-1.95-.44-3.88-1.44-5.56-1.06-1.62-2.56-2.87-4.37-3.56-2.31-.94-4.81-1.31-7.38-1.25-1.62,0-3.06,0-4.25.06-1.25-.06-2.13,0-2.56.06ZM120,68.57c-1.87-1-3.87-1.69-6-2.13-2.31-.5-4.62-.81-7-.81-1.25-.06-2.56.13-3.75.44-.81.19-1.5.63-1.94,1.25-.31.5-.5,1.13-.5,1.69s.25,1.12.63,1.63c.56.69,1.31,1.25,2.13,1.69,1.45.75,2.93,1.44,4.44,2.06,3.38,1.13,6.63,2.69,9.63,4.56,2.06,1.31,3.75,3.06,4.94,5.19,1,2,1.5,4.19,1.44,6.44.06,2.94-.81,5.88-2.44,8.31-1.74,2.49-4.18,4.43-7,5.56-3.06,1.31-6.81,2-11.31,2-2.87,0-5.69-.25-8.5-.81-2.2-.38-4.35-1.05-6.37-2-.44-.25-.75-.69-.69-1.19v-10.88c0-.19.06-.44.25-.56.19-.12.37-.06.56.06,2.44,1.44,5,2.44,7.75,3.06,2.38.63,4.88.94,7.37.94s4.06-.31,5.19-.87c1-.44,1.69-1.5,1.69-2.63,0-.87-.5-1.69-1.5-2.5-1-.81-3.06-1.75-6.13-2.94-3.14-1.11-6.12-2.62-8.87-4.5-1.96-1.4-3.58-3.21-4.75-5.31-1-2-1.5-4.19-1.44-6.37,0-2.69.75-5.25,2.12-7.56,1.56-2.5,3.88-4.5,6.56-5.75,2.94-1.5,6.63-2.19,11.06-2.19,2.56,0,5.19.19,7.75.56,1.88.25,3.69.75,5.37,1.44.25.06.5.31.63.56.06.25.12.5.12.75v10.19c0,.25-.12.5-.31.63-.56.12-.88.12-1.13,0Z"
                  fill="#31a8ff"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-ai" viewBox="0 0 150 150">
          <defs>
            <clipPath id="ai-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="illustrator">
            <g clipPath="url(#ai-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#300"
                />
                <path
                  d="M72.5,89.26h-23.25l-4.75,14.69c-.12.56-.62.94-1.19.87h-11.75c-.69,0-.87-.37-.69-1.12l20.13-57.94c.19-.62.38-1.31.62-2.06.25-1.31.37-2.69.37-4.06-.06-.31.19-.63.5-.69h16.19c.5,0,.75.19.81.5l22.81,64.38c.19.69,0,1-.62,1h-13.06c-.44.06-.87-.25-1-.69l-5.13-14.88ZM52.87,76.57h15.88c-.38-1.31-.88-2.87-1.44-4.5-.56-1.69-1.12-3.5-1.69-5.37-.63-1.94-1.19-3.81-1.81-5.75-.62-1.94-1.19-3.75-1.69-5.56-.5-1.75-.94-3.38-1.37-4.88h-.13c-.56,2.69-1.25,5.38-2.12,8.06-.94,3-1.88,6.13-2.88,9.25-.81,2.95-1.72,5.87-2.75,8.75ZM106.25,49.88c-2.06.06-4.06-.75-5.56-2.19-1.44-1.56-2.19-3.63-2.13-5.75-.06-2.13.75-4.12,2.25-5.56,1.5-1.44,3.5-2.19,5.56-2.19,2.44,0,4.31.75,5.69,2.19,1.39,1.52,2.13,3.51,2.06,5.56.06,2.12-.69,4.19-2.19,5.75-1.44,1.5-3.56,2.31-5.69,2.19ZM99.25,104.13v-48.12c0-.63.25-.88.81-.88h12.37c.56,0,.81.31.81.88v48.12c0,.69-.25,1-.81,1h-12.25c-.63,0-.94-.37-.94-1Z"
                  fill="#ff9a00"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-anim" viewBox="0 0 150 150">
          <defs>
            <clipPath id="ani-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="Animate">
            <g clipPath="url(#ani-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#00005b"
                />
                <path
                  d="M60.3,92.34h-23.8l-4.89,15.02c-.06.26-.21.49-.41.66-.21.17-.46.26-.73.27h-12.15c-.69,0-.93-.38-.72-1.13l20.69-59.05.27-.81c.11-.34.23-.71.34-1.15.27-1.37.41-2.77.41-4.17-.01-.1,0-.2.03-.29.03-.09.08-.18.15-.25.07-.07.16-.12.25-.15.09-.03.19-.04.29-.03h16.38c.48,0,.75.17.82.52l23.3,65.49c.21.69,0,1.03-.62,1.03h-13.39c-.23.03-.46-.03-.65-.17-.19-.13-.32-.33-.38-.55l-5.21-15.23ZM40.25,79.63h16.28l-.23-.77-.37-1.21-.54-1.74-1.05-3.28-2.85-9.03c-.51-1.62-1-3.25-1.48-4.88l-.53-1.86-.43-1.54-.53-1.93-.13-.46h-.1c-.52,2.47-1.14,4.92-1.88,7.34l-.7,2.23-1.67,5.4-1.08,3.49-.46,1.46-.45,1.42-.45,1.39c-.44,1.32-.88,2.64-1.34,3.96ZM87.77,107.3v-37.98c0-.26,0-.53,0-.8v-.84s-.02-.88-.02-.88l-.03-1.4-.03-1.22c-.02-.59-.04-1.18-.07-1.77l-.05-1.14-.08-1.41-.06-1.03-.04-.53-.03-.31c-.04-.1-.05-.21-.03-.32.02-.11.07-.21.14-.29.08-.07.18-.13.29-.16.11-.04.22-.05.33-.04h10.29c.36-.01.71.06,1.03.21.28.14.47.41.51.72l.46,1.39c.19.68.31,1.38.36,2.09,1.99-1.74,4.3-3.09,6.8-3.97,2.49-.86,5.1-1.3,7.73-1.29,2.05,0,4.08.34,6.03.98,2.25.72,4.29,1.95,5.99,3.59,1.69,1.64,2.97,3.66,3.75,5.89,1.03,2.64,1.43,6.06,1.43,10.25v30.25c0,.62-.27.93-.82.93l-12.04.11c-.14.02-.28,0-.42-.04-.13-.04-.26-.12-.36-.22-.1-.1-.18-.22-.22-.36-.04-.13-.06-.28-.04-.42v-28.7c-.03-1.92-.46-3.82-1.24-5.57-.55-1.29-1.46-2.4-2.63-3.19-1.31-.81-2.84-1.2-4.38-1.13-1.66-.02-3.3.27-4.84.88-1.41.56-2.7,1.38-3.81,2.42v35.3c0,.62-.27.93-.82.93h-12.14c-.13.02-.25,0-.38-.03-.12-.04-.23-.11-.32-.2-.09-.09-.16-.2-.2-.32-.04-.12-.05-.25-.03-.37"
                  fill="#99f"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-xd" viewBox="0 0 150 150">
          <defs>
            <clipPath id="xd-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="XD">
            <g clipPath="url(#xd-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#470137"
                />
                <path
                  d="M79,44.74l-19.17,31.63,20.5,33.59c.13.24.17.51.1.77-.03.11-.1.14-.21.14h-.12s-.14,0-.14,0c-.08,0-.16,0-.26.02h-15.07c-.8-.03-1.37-.14-1.72-.72-1.37-2.66-2.74-5.33-4.12-7.99-1.23-2.37-2.5-4.73-3.8-7.06l-.57-1.03c-1.56-2.77-3.08-5.55-4.59-8.35h-.1c-1.39,2.77-2.81,5.52-4.28,8.24-1.48,2.75-2.94,5.48-4.38,8.19-1.44,2.71-2.92,5.41-4.43,8.09-.24.55-.65.66-1.21.68h-.23s-14.12,0-14.12,0h-.06s-.2.02-.2.02c-.11,0-.18-.02-.2-.19-.04-.25.02-.51.15-.72l19.89-32.66-19.37-32.77c-.21-.27-.24-.5-.1-.67.08-.09.17-.16.28-.2.11-.04.22-.06.34-.06h14.53c.32-.02.63.04.93.15.25.14.46.33.62.57,1.24,2.75,2.61,5.5,4.12,8.24,1.5,2.73,3.03,5.44,4.59,8.14,1.53,2.66,2.96,5.37,4.28,8.14h.1c1.35-2.77,2.74-5.52,4.17-8.24,1.41-2.68,2.85-5.38,4.33-8.09,1.46-2.68,2.88-5.37,4.28-8.09.08-.25.22-.48.41-.67.25-.13.54-.18.82-.15h13.5c.12-.03.26-.02.37.03.12.05.22.14.28.25.06.11.09.24.08.37-.01.13-.07.25-.16.34l-.05.05ZM109.28,112.23h-.71c-4.74.08-9.44-.91-13.76-2.88-4.02-1.86-7.38-4.9-9.63-8.71-2.27-3.78-3.44-8.49-3.5-14.12v-.46c-.04-4.73,1.17-9.39,3.5-13.5,2.34-4.07,5.74-7.43,9.85-9.7l.35-.19c4.46-2.47,9.86-3.71,16.18-3.71h.28s.32.01.32.01l.35.02.39.02.66.05.75.06.55.05v-20.3c0-.48.21-.72.62-.72h12.98c.08-.01.17,0,.25.02.08.03.15.07.21.13.06.06.11.13.13.21.03.08.03.17.02.25v60.9c0,1.02.04,2.12.12,3.3l.19,2.67.1,1.55c.01.21-.04.43-.15.61-.11.18-.27.33-.47.42-3.35,1.4-6.84,2.43-10.41,3.09-3.03.56-6.1.87-9.18.92ZM114.86,99.46v-28.13c-.56-.15-1.13-.25-1.7-.31-.7-.07-1.41-.11-2.11-.1-2.5-.03-4.97.54-7.21,1.65-2.18,1.09-4.05,2.72-5.41,4.74-1.36,1.99-2.06,4.59-2.11,7.79v.35c-.05,2.25.31,4.48,1.08,6.59.62,1.7,1.61,3.25,2.89,4.53,1.22,1.18,2.7,2.06,4.33,2.58,1.71.55,3.51.83,5.31.82.96,0,1.85-.03,2.68-.1.66-.05,1.31-.16,1.95-.32l.32-.09Z"
                  fill="#ff61f6"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-inDesign" viewBox="0 0 150 150">
          <defs>
            <clipPath id="ID-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="In_Design">
            <g clipPath="url(#ID-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#49021f"
                />
                <path
                  d="M52.79,43.95v65.64c0,.69-.31,1.03-.93,1.03h-12.47c-.55,0-.83-.34-.82-1.03V43.95c0-.55.31-.82.93-.82h12.47c.1-.01.21,0,.31.02.1.03.19.08.27.15.08.07.14.16.18.25.04.1.06.2.06.31v.08ZM90.34,111.64h-.66c-4.74.08-9.44-.91-13.76-2.88-4.02-1.86-7.38-4.9-9.63-8.71-2.28-3.79-3.45-8.5-3.5-14.15v-.43c-.04-4.73,1.17-9.39,3.5-13.5,2.34-4.08,5.75-7.44,9.87-9.71l.33-.18c4.46-2.47,9.86-3.71,16.18-3.71h.13s.3,0,.3,0h.33s.37.03.37.03l.41.03.45.03,1.02.08.28.02v-20.3c0-.48.21-.72.62-.72h12.98c.08-.01.17,0,.25.02.08.03.15.07.21.13.06.06.11.13.13.21.03.08.03.17.02.25v60.9c0,1.27.06,2.54.16,3.81l.1,1.33.09,1.24.08,1.14c.01.21-.04.43-.15.61s-.27.33-.47.42c-3.35,1.4-6.84,2.43-10.41,3.09-3.05.56-6.13.87-9.23.92M95.96,98.87v-28.13c-.56-.15-1.13-.25-1.7-.31-.7-.07-1.41-.11-2.11-.1-2.5-.02-4.97.54-7.21,1.65-2.18,1.09-4.05,2.72-5.41,4.74-1.41,2.06-2.11,4.77-2.11,8.14-.05,2.25.32,4.48,1.08,6.59.62,1.7,1.61,3.25,2.89,4.53,1.22,1.18,2.71,2.06,4.33,2.58,1.71.55,3.51.83,5.31.83.96,0,1.85-.03,2.68-.1.66-.05,1.31-.16,1.95-.32l.32-.09Z"
                  fill="#f36"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-premiere" viewBox="0 0 150 150">
          <defs>
            <clipPath id="prem-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="Premiere">
            <g clipPath="url(#prem-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#00005b"
                />
                <path
                  d="M31.64,107.04V42.66c0-.44.19-.69.63-.69,1.06,0,2.06,0,3.5-.06,1.5-.06,3.06-.06,4.75-.12,1.69-.06,3.5-.06,5.44-.12,1.94-.06,3.81-.06,5.69-.06,5.13,0,9.38.63,12.88,1.94,3.14,1.07,6,2.82,8.37,5.12,2.01,2.02,3.57,4.45,4.56,7.12.94,2.63,1.44,5.31,1.44,8.13,0,5.37-1.25,9.81-3.75,13.31-2.5,3.5-6,6.12-10.06,7.62-4.25,1.56-8.94,2.13-14.06,2.13-1.5,0-2.5,0-3.13-.06-.62-.06-1.5-.06-2.69-.06v20.06c.06.44-.25.81-.69.87h-12.12c-.5,0-.75-.25-.75-.81v.06ZM45.27,54.1v21c.88.06,1.69.13,2.44.13h3.31c2.44,0,4.87-.38,7.19-1.12,2-.56,3.75-1.75,5.13-3.31,1.31-1.56,1.94-3.69,1.94-6.44.06-1.95-.44-3.88-1.44-5.56-1.06-1.62-2.56-2.87-4.37-3.56-2.31-.94-4.81-1.31-7.38-1.25-1.62,0-3.06,0-4.25.06-1.25-.06-2.13,0-2.56.06ZM87.89,57.79h10.94c.63,0,1.12.44,1.31,1,.19.5.31,1,.37,1.56.12.63.25,1.31.31,1.94.06.69.13,1.44.13,2.25,1.88-2.19,4.14-4.01,6.69-5.38,2.88-1.62,6.19-2.44,9.5-2.44.44-.06.81.25.88.69v12.44c0,.5-.31.69-1,.69-2.25-.06-4.56.12-6.75.62-1.81.38-3.56.94-5.25,1.69-1.19.56-2.31,1.31-3.19,2.31v31.87c0,.63-.25.87-.81.87h-12.31c-.5.06-.94-.25-1-.75v-34.87c0-1.5,0-3.06-.06-4.69-.06-1.62-.06-3.25-.13-4.88,0-1.44-.12-2.81-.25-4.25-.06-.31.12-.63.44-.69,0-.06.13-.06.19,0Z"
                  fill="#99f"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-after_effects" viewBox="0 0 150 150">
          <defs>
            <clipPath id="AE-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="AfterEffects">
            <g clipPath="url(#AE-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#00005b"
                />
                <path
                  d="M61.62,91.48h-23.25l-4.75,14.75c-.12.56-.62.94-1.19.88h-11.75c-.69,0-.87-.38-.69-1.13l20.13-57.69c.19-.62.38-1.19.62-1.94.25-1.31.38-2.69.38-4.06-.06-.31.19-.62.5-.69h16.19c.44,0,.75.19.81.5l22.81,63.75c.19.69,0,1-.62,1h-13.06c-.44.06-.87-.25-1-.69l-5.13-15v.31ZM41.99,79.04h15.87c-.38-1.31-.88-2.87-1.44-4.5-.56-1.69-1.12-3.5-1.69-5.37-.62-1.94-1.19-3.81-1.81-5.75-.63-1.94-1.19-3.75-1.69-5.56-.5-1.75-.94-3.38-1.38-4.87h-.12c-.56,2.69-1.25,5.38-2.13,8.06-.94,3-1.87,6.13-2.87,9.25-.81,3.19-1.81,6.12-2.75,8.75ZM118.24,85.85h-19.81c.25,1.94.87,3.87,1.94,5.56,1.13,1.69,2.69,3,4.56,3.75,2.5,1.06,5.25,1.63,8,1.56,2.19-.06,4.38-.25,6.5-.69,1.91-.25,3.77-.73,5.56-1.44.31-.25.5-.12.5.5v9.56c0,.25-.06.5-.12.75-.12.19-.25.31-.44.44-2,.88-4.1,1.51-6.25,1.87-2.92.56-5.9.81-8.88.75-4.75,0-8.75-.75-12-2.19-3.06-1.31-5.75-3.37-7.88-5.94-1.98-2.41-3.45-5.19-4.31-8.19-.87-2.94-1.31-6-1.31-9.12,0-3.38.5-6.69,1.56-9.94,1-3.13,2.59-6.04,4.69-8.56,2.06-2.5,4.62-4.5,7.56-5.94,2.94-1.44,6.44-1.94,10.44-1.94,3.31-.06,6.62.56,9.69,1.94,2.56,1.13,4.81,2.81,6.56,5,1.62,2.12,2.94,4.5,3.75,7.12.81,2.5,1.19,5.06,1.19,7.62,0,1.5-.06,2.81-.13,4-.12,1.19-.19,2.06-.25,2.63-.06.44-.44.81-.87.81-.38,0-1.06.06-2.06.13-1,.12-2.19.19-3.63.19s-2.94-.25-4.56-.25ZM98.43,76.73h13.19c1.62,0,2.81,0,3.56-.06.5-.06,1-.19,1.44-.5v-.63c0-.79-.12-1.57-.38-2.31-1.12-3.5-4.44-5.87-8.12-5.75-1.7-.1-3.38.3-4.86,1.15-1.47.84-2.67,2.09-3.45,3.6-.75,1.44-1.19,2.94-1.37,4.5Z"
                  fill="#99f"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-figma" viewBox="0 0 150 150">
          <defs>
            <clipPath id="figma-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
            <mask
              id="fig-mask"
              x="35.74"
              y="16.41"
              width="78.14"
              height="117.19"
              maskUnits="userSpaceOnUse"
            >
              <g id="mask0_204_5">
                <path d="M35.74,16.41h78.14v117.19H35.74V16.41Z" fill="#fff" />
              </g>
            </mask>
          </defs>
          <g id="Figma">
            <g clipPath="url(#figma-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#f4f2ed"
                />
                <g mask="url(#fig-mask)">
                  <g>
                    <path
                      d="M55.28,133.59c10.78,0,19.53-8.75,19.53-19.53v-19.53h-19.53c-10.78,0-19.53,8.75-19.53,19.53s8.75,19.53,19.53,19.53Z"
                      fill="#0acf83"
                    />
                    <path
                      d="M35.75,75c0-10.78,8.75-19.53,19.53-19.53h19.53v39.06h-19.53c-10.78,0-19.53-8.75-19.53-19.53Z"
                      fill="#a259ff"
                    />
                    <path
                      d="M35.75,35.94c0-10.78,8.75-19.53,19.53-19.53h19.53v39.06h-19.53c-10.78,0-19.53-8.75-19.53-19.53Z"
                      fill="#f24e1e"
                    />
                    <path
                      d="M74.81,16.41h19.53c10.78,0,19.53,8.75,19.53,19.53s-8.75,19.53-19.53,19.53h-19.53V16.41Z"
                      fill="#ff7262"
                    />
                    <path
                      d="M113.88,75c0,10.78-8.75,19.53-19.53,19.53s-19.53-8.75-19.53-19.53,8.75-19.53,19.53-19.53,19.53,8.75,19.53,19.53Z"
                      fill="#1abcfe"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-canva" viewBox="0 0 150 150">
          <g id="canva">
            <path
              d="M114.84,0H35.15C15.74,0,0,15.74,0,35.16v79.69c0,19.41,15.74,35.15,35.15,35.15h79.69c19.42,0,35.16-15.74,35.16-35.15V35.16c0-19.42-15.74-35.16-35.16-35.16ZM122.91,72.66c-1.68.45-3.57,2.33-4.56,4.53-1.98,4.38-.93,9.54,1.92,9.54,1.14,0,3.15-2.26,3.93-4.44.93-2.53,2.88-4.11,4.35-3.54.81.3.87,1.11.36,3.66-.57,2.79-.66,5.4-.21,6.6.18.44.72,1.29,1.23,1.85.96,1.08.99,1.47.18,1.99-.39.27-.9.15-2.16-.54-1.74-.9-3.24-2.53-3.78-4.05l-.33-.9-1.2.9c-.69.48-1.77,1.02-2.4,1.19-2.49.66-5.55-1.04-6.99-3.92-.57-1.12-.75-4.38-.33-5.64q.24-.69-.72-.21c-.51.27-1.59.56-2.43.66-1.38.15-1.59.3-2.97,2.04-1.95,2.42-5.4,5.7-6.81,6.39-3,1.49-3.99,1.07-4.77-2.02l-.54-2.07-1.29,1.14c-1.65,1.45-4.95,3.19-6.84,3.61-1.8.39-3.72-.19-4.5-1.39-1.17-1.79-.78-5.6,1.08-10.73,1.38-3.81.39-3.87-3.09-.24-2.58,2.73-3.69,4.68-4.41,7.71-.75,3.15-1.65,4.28-3.69,4.77-1.23.27-1.8-.49-1.56-2.13l.18-1.33-1.14.79c-1.62,1.11-3.66,2.13-5.07,2.52-1.41.38-3.27-.03-3.72-.82q-.81-1.37-2.07-.38c-2.73,2.22-6.63,1.58-8.61-1.35l-.63-.93-1.98,1.83c-5.7,5.22-12.84,7.56-18.12,5.93-6.72-2.03-10.44-7.8-10.38-16.1.03-8.34,3.72-17.13,9.93-23.64,3.51-3.67,6.81-5.83,10.17-6.64,2.43-.6,3.9-.57,6.21.15,1.59.48,2.34.93,3.42,2.01,2.1,2.14,2.58,3.3,2.58,6.51,0,2.41-.09,2.86-.81,4.11-1.38,2.34-4.59,4.5-6.81,4.56-1.56.04-1.5-.66.21-2.45,2.28-2.38,2.61-3.27,2.61-6.82-.03-3.42-.45-4.58-2.04-5.54-1.32-.81-2.76-.75-4.86.23-5.46,2.62-11.37,11.32-13.68,20.23-3.06,11.88,2.37,21.38,11.31,19.76,2.61-.48,7.53-2.99,9.66-4.98,1.77-1.61,1.77-1.64,1.95-3.65.39-4.21,3.36-8.4,7.32-10.35,1.83-.91,2.28-.99,4.74-.99s2.88.12,4.02.74c3.63,2.08,2.88,6.91-1.05,6.91-2.28,0-3.45-1.18-1.8-1.8,1.62-.6,1.02-2.85-.87-3.36-2.22-.57-4.74.93-6.33,3.81-1.92,3.48-2.01,7.62-.18,9.5,1.77,1.89,3.99.4,5.7-3.9.9-2.18,2.19-3.36,3.69-3.36,1.32,0,1.56.81.99,3.28-.84,3.81-.27,4.79,2.1,3.63.78-.37,2.07-1.2,2.85-1.8l1.47-1.17.99-5.2c1.08-5.81,1.5-6.6,3.72-7.01,2.13-.4,2.61.66,1.83,3.98l-.42,1.87,1.56-1.6c3.69-3.78,8.22-5.64,9.78-4.07.84.83.75,1.89-.45,5.6-.57,1.78-1.35,4.57-1.71,6.16-.54,2.39-.57,2.97-.27,3.36.96,1.14,3.9-.04,6.51-2.59l1.53-1.49.18-3.34c.18-3.84.54-5.21,1.56-6.45.96-1.13,2.7-1.97,3.63-1.73s.93,1.14.09,3.78c-1.17,3.63-1.05,11.99.15,11.99.48,0,2.94-2.57,4.5-4.73l1.17-1.6-.93-.95c-1.62-1.71-2.01-2.82-2.01-5.62,0-2.03.15-2.78.66-3.78.84-1.55,2.16-2.69,3.72-3.15,1.65-.5,3.69.33,4.53,1.83.84,1.53.63,4.95-.45,7.3l-.78,1.7h1.05c1.44,0,2.01-.35,4.59-2.78,1.35-1.29,2.91-2.41,4.08-2.95,4.59-2.15,9.99-1.04,10.89,2.26.75,2.64-.9,4.5-3.78,4.28-2.07-.15-2.46-.69-1.26-1.7,2.16-1.81,0-4.11-3.09-3.27Z"
              fill="#00c4cc"
            />
            <path
              d="M105.96,68.79c-.66.66-.42,3.3.42,4.98.42.87.87,1.56,1.02,1.56.12,0,.39-.69.6-1.53.75-3.12-.6-6.45-2.04-5.01Z"
              fill="#00c4cc"
            />
          </g>
        </symbol>

        <symbol id="symb-affinity" viewBox="0 0 150 150">
          <defs>
            <radialGradient
              id="affin-radial-gradient"
              cx="-489.95"
              cy="132.58"
              fx="-489.95"
              fy="132.58"
              r=".15"
              gradientTransform="translate(508808.76 137642.85) scale(1038.26 -1038.26)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#6be1fb" />
              <stop offset="1" stopColor="#38bdfa" />
            </radialGradient>
          </defs>
          <g id="Affinity">
            <path
              d="M150,14.65c0-8.08-6.56-14.65-14.65-14.65H14.65C6.56,0,0,6.56,0,14.65v120.7c0,8.08,6.56,14.65,14.65,14.65h120.7c8.08,0,14.65-6.56,14.65-14.65V14.65Z"
              fill="#134881"
              fillRule="evenodd"
            />
            <path
              d="M139.02,133.2c-.02,3.21-2.64,5.81-5.86,5.81h-59.13l-25.28-43.78h90.27v37.97h0ZM10.99,133.15v-25.71L66.68,10.99h21.76l-47.05,81.49,26.87,46.53H16.85c-3.23,0-5.86-2.63-5.86-5.86ZM82.35,90.24h-22c-2.46,0-4.73-1.29-5.95-3.42-1.23-2.13-1.23-4.75,0-6.88l11.01-19.07,16.95,29.36ZM133.16,10.99c3.22,0,5.83,2.6,5.86,5.81v73.44h-50.9l-19.84-34.35,25.93-44.9h38.95Z"
              fill="url(#affin-radial-gradient)"
              fillRule="evenodd"
            />
          </g>
        </symbol>

        <symbol id="symb-html" viewBox="0 0 150 150">
          <defs>
            <clipPath id="html-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="HTML">
            <g clipPath="url(#html-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#e14e1d"
                />
                <path
                  d="M28.12,22.27l5.04,56.6h64.87l-2.18,24.28-20.89,5.65-20.85-5.64-1.39-15.59h-18.79l2.69,30.05,38.34,10.65,38.39-10.65,5.15-57.46H50.29l-1.71-19.17h71.62l1.68-18.72H28.12Z"
                  fill="#fff"
                />
                <path
                  d="M75,22.27H28.12l5.04,56.6h41.83v-18.71h-24.71l-1.71-19.17h26.43v-18.72ZM75,108.78h-.02s-20.85-5.63-20.85-5.63l-1.39-15.59h-18.79l2.69,30.05,38.34,10.65h.03s0-19.48,0-19.48Z"
                  fill="#ebebeb"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-css" viewBox="0 0 150 150">
          <defs>
            <clipPath id="css-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="CSS">
            <g clipPath="url(#css-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#0277bd"
                />
                <path
                  d="M31.5,60.15l1.68,18.72h41.88v-18.72H31.5ZM75.06,22.27H28.12l1.7,18.72h45.23v-18.72ZM75.06,128.23v-19.47l-.08.02-20.84-5.63-1.33-14.93h-18.79l2.62,29.39,38.34,10.64.09-.02Z"
                  fill="#ebebeb"
                />
                <path
                  d="M98.04,78.86l-2.17,24.27-20.87,5.63v19.47l38.37-10.63.28-3.16,4.4-49.27.46-5.03,3.38-37.88h-46.88v18.72h26.37l-1.7,19.17h-24.67v18.72h23.05Z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-js" viewBox="0 0 150 150">
          <defs>
            <clipPath id="js-clippath">
              <rect
                width="150"
                height="150"
                rx="34.71"
                ry="34.71"
                fill="none"
              />
            </clipPath>
            <mask
              id="js-mask"
              x="0"
              y="0"
              width="150"
              height="150"
              maskUnits="userSpaceOnUse"
            >
              <g id="mask0_204_40" data-name="mask0 204 40">
                <path d="M0,0h150v150H0V0Z" fill="#fff" />
              </g>
            </mask>
          </defs>
          <g id="JavaScript">
            <g clipPath="url(#js-clippath)">
              <g mask="url(#js-mask)">
                <path
                  d="M6.22,0h137.55c3.44,0,6.22,2.79,6.22,6.22v137.55c0,3.44-2.79,6.22-6.22,6.22H6.22c-3.44,0-6.22-2.79-6.22-6.22V6.22C0,2.79,2.79,0,6.22,0ZM114.67,125.75c-4.92,0-8.33-1.81-10.97-4.62-2-2.13-5.18-2.64-7.7-1.17l-.84.49c-3.48,2.02-4.19,6.8-1.38,9.68,4.74,4.88,11.77,8.13,21.22,8.13,13.39,0,23.36-6.95,23.36-19.64,0-11.77-6.76-17-18.74-22.14l-3.52-1.51c-6.05-2.62-8.67-4.33-8.67-8.56,0-3.42,2.63-6.04,6.75-6.04,2.53,0,4.49.67,6.2,2.22,2.11,1.92,5.19,2.32,7.6.78l.47-.3c3.58-2.3,3.92-7.26.8-10.01-4-3.53-8.94-4.98-15.07-4.98-12.59,0-20.64,8.05-20.64,18.63,0,11.47,6.75,16.9,16.93,21.23l3.53,1.51c6.43,2.81,10.26,4.52,10.26,9.36,0,4.04-3.73,6.96-9.57,6.96ZM60.04,125.66c-2.81,0-4.67-1.12-6.17-2.82-2.03-2.31-5.37-2.93-8-1.34l-.83.5c-3.42,2.07-4.03,6.78-1.26,9.66,3.76,3.91,9.22,6.58,16.86,6.58,12.49,0,21.05-6.64,21.05-21.24v-41.9c0-3.44-2.79-6.22-6.22-6.22h-1.64c-3.44,0-6.22,2.79-6.22,6.22v41.71c0,7.04-2.93,8.85-7.56,8.85"
                  fill="#fff"
                  fillRule="evenodd"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-pug" viewBox="0 0 150 150">
          <g id="Pug">
            <path
              d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
              fill="#fff"
            />
            <g>
              <path
                d="M118.88,60.41c-.24-4.33.96-8.42-.96-11.78-4.81-8.42-16.83-13.22-40.88-13.22v-.24.24c-26.45,0-37.75,4.81-42.56,13.22-1.63,3.7-2.38,7.74-2.16,11.78-.89,3.7-1.29,7.5-1.2,11.3.72,5.29,1.2,10.58,1.92,15.39.72,4.09,6.49,7.21,7.21,11.07,1.44,10.34,10.58,15.15,37.03,15.15v1.2h-.46v-1.2c24.04,0,34.13-4.81,35.59-15.15.46-3.85,5.29-6.97,6-11.07.72-4.81.96-10.1,1.68-15.39,0-3.8-.41-7.58-1.2-11.3Z"
                fill="#efcca3"
              />
              <path
                d="M75.84,64.25c3.93.36,7.57,2.26,10.1,5.29,3.37,2.89,8.9,4.81,11.3,7.45,2.93,2.42,5.17,5.57,6.49,9.14.91,3.37,1.4,6.85,1.44,10.34,0,1.2.72.96,2.64,0,3.81-2.32,7.22-5.25,10.1-8.66-.72,4.09-5.77,7.69-6.25,11.53-1.44,10.34-11.53,15.39-36.31,15.39h1.44"
                fill="#ccac8d"
              />
              <path
                d="M91.23,56.08c.96,3.13,4.09,13.95-2.16,10.34,2.28,1.79,3.82,4.36,4.33,7.21.3,1.53,1.02,2.95,2.08,4.09,1.06,1.15,2.41,1.98,3.92,2.4,4.15.62,8.38-.42,11.78-2.89,1.99-1.91,3.36-4.38,3.92-7.09.56-2.7.28-5.51-.79-8.06-.73-2.07-2.06-3.88-3.81-5.21-1.75-1.33-3.86-2.11-6.05-2.25-4.53-1.21-14.17-2.17-13.21,1.44Z"
                fill="#ccac8d"
              />
              <path d="M103.5,76.52c4.91,0,8.9-3.98,8.9-8.9s-3.98-8.9-8.9-8.9-8.9,3.98-8.9,8.9,3.98,8.9,8.9,8.9Z" />
              <path
                d="M101.09,65.94c1.33,0,2.4-1.08,2.4-2.4s-1.08-2.4-2.4-2.4-2.4,1.08-2.4,2.4,1.08,2.4,2.4,2.4Z"
                fill="#fff"
              />
              <path
                d="M89.79,67.14c4.52,3.17,8.71,6.8,12.5,10.82,4.33,5.54,4.33,6.49,4.33,6.49l-3.13,1.44c-2.34-4.56-5.71-8.51-9.86-11.53-5.54-3.13-6.25-5.77-6.25-5.77l2.4-1.46Z"
                fill="#efcca3"
              />
              <path
                d="M76.08,64.25c-4.14.35-8,2.23-10.82,5.29-3.37,2.89-9.38,4.81-11.53,7.45-3,2.41-5.32,5.56-6.73,9.14-.91,3.37-1.4,6.85-1.44,10.34,0,1.2.24,1.44-2.89,0-3.86-2.25-7.29-5.18-10.1-8.66.72,4.09,5.77,7.69,6.25,11.53,1.44,10.1,11.53,15.15,36.31,15.15h1.68"
                fill="#ccac8d"
              />
              <path
                d="M99.17,80.84c-2.76-3.66-6.31-6.65-10.4-8.73-4.08-2.08-8.59-3.21-13.17-3.3-4.58.12-9.07,1.26-13.15,3.34-4.08,2.08-7.64,5.05-10.42,8.69-1.85,1.93-3.24,4.25-4.08,6.79-.83,2.54-1.08,5.23-.73,7.88,0,21.4,7.45,14.91,12.5,17.56,5.03,1.67,10.38,2.17,15.63,1.44,5.25.74,10.6.25,15.63-1.44,5.05-2.64,12.5,3.85,12.5-17.56.59-2.61.51-5.33-.25-7.9-.76-2.57-2.16-4.9-4.08-6.77Z"
                fill="#56332b"
              />
              <path
                d="M75.12,74.83c-.18,4.01-.91,7.97-2.16,11.78l2.64-.72-.48-11.06Z"
                fill="#442823"
              />
              <path
                d="M75.84,74.83c.18,4.01.91,7.97,2.16,11.78l-2.64-.72.48-11.06Z"
                fill="#442823"
              />
              <path
                d="M67.43,72.43c-.96-2.4,2.64-6.25,8.42-6.25s9.38,3.85,8.42,6.25c-.96,2.4-4.81,3.13-8.42,3.13-3.85,0-7.46-.72-8.42-3.13Z"
                fill="#56332b"
              />
              <path d="M75.84,74.83c0-.46,3.37-.46,5.29-1.68,0,0-3.85,1.2-4.57.72-.5-.44-.83-1.03-.96-1.68-.13.65-.47,1.24-.96,1.68-.72.46-5.05-.72-5.05-.72,1.89.42,3.74.98,5.54,1.68v1.92c-.15,3.13,0,6.27.46,9.38.72.96.46-6.73.46-9.38-.17-.63-.24-1.28-.2-1.92Z" />
              <path
                d="M75.84,88.54c2.72.36,5.29,1.44,7.45,3.13-1.88-2.44-4.49-4.21-7.45-5.05-3.39.74-6.39,2.71-8.42,5.54,2.37-2.04,5.31-3.3,8.42-3.61Z"
                fill="#7f4a41"
              />
              <path
                d="M75.36,106.32c-3.77-.21-7.5-.94-11.07-2.16-.72-.24-1.44.24-2.16,0-5.81-1.65-10.95-5.1-14.67-9.86v.96c0,21.4,7.45,14.91,12.5,17.56,5.03,1.67,10.38,2.17,15.63,1.44,5.25.74,10.6.25,15.63-1.44,5.05-2.64,12.5,3.85,12.5-17.56v-2.16c-3.56,5.23-8.82,9.06-14.89,10.83-.72.24-1.92-.24-2.64-.24-3.43,1.5-7.1,2.39-10.83,2.63Z"
                fill="#442823"
              />
              <path
                d="M65.5,94.79s-2.64,7.69-.72,11.07l-2.4-.96c.79-3.44,1.83-6.82,3.12-10.11ZM85.7,94.79s2.64,7.69.72,11.07l2.42-.96c-.68-3.47-1.73-6.86-3.14-10.11Z"
                fill="#442823"
              />
              <path
                d="M59.25,56.08c-.96,3.13-4.09,13.95,2.16,10.34-2.28,1.79-3.82,4.36-4.33,7.21-.3,1.53-1.02,2.95-2.08,4.09-1.06,1.15-2.41,1.98-3.92,2.4-4.16.63-8.39-.4-11.8-2.87-1.99-1.91-3.36-4.38-3.92-7.09-.56-2.7-.28-5.51.79-8.06.73-2.07,2.06-3.88,3.81-5.21,1.75-1.33,3.86-2.11,6.05-2.25,4.58-1.23,14.19-2.19,13.23,1.42Z"
                fill="#ccac8d"
              />
              <path d="M75.6,86.61c2.98.84,5.65,2.54,7.66,4.9,2.01,2.35,3.28,5.25,3.64,8.33v-.46c-.08-3.19-1.23-6.27-3.29-8.71-2.05-2.45-4.88-4.12-8.01-4.75-3.15.59-6,2.25-8.06,4.71-2.06,2.46-3.21,5.55-3.24,8.76v.46c.4-3.06,1.68-5.94,3.69-8.29,2.01-2.35,4.65-4.06,7.61-4.94Z" />
              <path
                d="M77.88,72.37c.38-.1.54-.81.34-1.58-.2-.77-.67-1.32-1.06-1.22-.38.1-.54.81-.34,1.58.2.77.67,1.32,1.06,1.22Z"
                fill="#331712"
              />
              <path
                d="M73.89,71.23c.24-.76.12-1.47-.26-1.59-.38-.12-.88.4-1.12,1.17-.24.76-.12,1.47.26,1.59.38.12.88-.4,1.12-1.17Z"
                fill="#331712"
              />
              <path d="M47.47,76.52c4.91,0,8.9-3.98,8.9-8.9s-3.98-8.9-8.9-8.9-8.9,3.98-8.9,8.9,3.98,8.9,8.9,8.9Z" />
              <path
                d="M49.87,65.94c1.33,0,2.4-1.08,2.4-2.4s-1.08-2.4-2.4-2.4-2.4,1.08-2.4,2.4,1.08,2.4,2.4,2.4Z"
                fill="#fff"
              />
              <path
                d="M78.23,67.62s-2.4.96-2.89,1.2c-1.01-.27-1.98-.67-2.89-1.2h5.77Z"
                fill="#7f4a41"
              />
              <path
                d="M60.7,67.14c-4.52,3.17-8.71,6.8-12.5,10.82-4.33,5.54-4.33,6.49-4.33,6.49l3.13,1.44c2.34-4.56,5.71-8.51,9.86-11.53,5.54-3.13,6.25-5.77,6.25-5.77l-2.4-1.46Z"
                fill="#efcca3"
              />
              <path
                d="M43.14,51.03c-1.68,4.44-4.81,8.17-8.9,10.58,2.55-.3,4.89-1.56,6.54-3.53,1.65-1.97,2.49-4.49,2.36-7.05ZM106.86,51.03c1.68,4.44,4.81,8.17,8.9,10.58-2.55-.3-4.89-1.56-6.54-3.53-1.65-1.97-2.49-4.49-2.36-7.05ZM90.27,64.97c-3.87-3.7-8.86-5.99-14.19-6.49h.72c-2.66-.03-5.3.53-7.71,1.66-2.41,1.12-4.55,2.78-6.23,4.84,3.97-3.14,8.89-4.84,13.95-4.81,4.84.35,9.5,2.01,13.47,4.81ZM83.05,51.75c-1.76-2.31-4.34-3.86-7.21-4.33h.72c-1.44.05-2.84.48-4.06,1.24-1.22.76-2.23,1.82-2.91,3.09,1.83-1.91,4.33-3.03,6.97-3.13,1.24.03,2.46.33,3.58.87,1.12.54,2.11,1.31,2.91,2.26ZM47.47,83.01c-2.52,1.3-5.42,1.64-8.18.96h-.96c-1.9-1.96-3.3-4.36-4.09-6.97,1,2.52,2.93,4.55,5.4,5.67,2.47,1.12,5.27,1.24,7.82.34ZM103.26,83.01c2.52,1.3,5.42,1.64,8.18.96h-.96c1.41-.57,2.64-1.52,3.53-2.76.89-1.23,1.42-2.7,1.52-4.22-.37,1.23-.99,2.37-1.82,3.34-.83.98-1.85,1.77-3,2.34-1.15.56-2.41.88-3.69.94-1.28.06-2.56-.15-3.76-.61Z"
                fill="#ccac8d"
              />
              <path
                d="M53,50.55c3.43-.67,6.98-.52,10.34.46,4.33,1.44.96,7.21,1.68,7.45,1.39-1.26,3.03-2.21,4.81-2.79,1.78-.58,3.67-.78,5.53-.57,8.18.46,9.14,4.09,10.34,3.37,1.2-.46-1.2-10.1,11.3-7.93,0,0-12.74-3.37-12.26,5.77-2.63-1.72-5.69-2.67-8.83-2.75-3.14-.08-6.24.71-8.96,2.29,0,0,2.64-8.9-13.95-5.29ZM49.63,38.05s-11.07,13.71-12.5,18.99c-1.68,5.29-2.89,27.41-4.33,30.54l-5.05-21.65,9.38-22.6,12.5-5.28ZM101.09,38.05s11.07,13.71,12.5,18.99c1.68,5.29,2.89,27.41,4.33,30.54l5.05-21.65-9.38-22.6-12.5-5.28Z"
                fill="#ccac8d"
              />
              <path
                d="M100.37,38.05c6.71,5.7,11.92,12.97,15.15,21.16,3.37,11.3,1.92,25.25,4.57,26.93,3.85,2.4,7.93-12.02,9.38-13.46,2.16-2.4,9.62-8.66,10.1-9.86.48-1.2-14.91-18.03-21.88-21.4-7.7-3.87-17.78-4.34-17.32-3.37Z"
                fill="#56332b"
              />
              <path
                d="M110.47,44.05c8.51,11.61,13.29,25.53,13.71,39.92l5.54-11.3c-4.16-10.88-10.74-20.66-19.24-28.62Z"
                fill="#442823"
              />
              <path
                d="M49.63,38.05c-6.71,5.7-11.92,12.97-15.15,21.16-3.37,11.3-1.92,25.25-4.57,26.93-3.85,2.4-7.93-12.02-9.38-13.46-2.16-2.4-9.62-8.66-10.1-9.86s14.91-18.03,21.88-21.4c7.7-3.87,17.78-4.34,17.32-3.37Z"
                fill="#56332b"
              />
              <path
                d="M39.53,44.05c-8.51,11.61-13.29,25.53-13.71,39.92l-5.53-11.32c4.15-10.87,10.73-20.65,19.23-28.6Z"
                fill="#442823"
              />
              <path
                d="M31.84,84.21c.38,2.56,1.28,5.02,2.64,7.21,1.68,1.68.46-1.44.46-1.44,0,0-1.68-.96-1.44-7.93.24-6.97-1.66,2.16-1.66,2.16ZM118.4,84.21c-.38,2.56-1.28,5.02-2.64,7.21-1.68,1.68-.46-1.44-.46-1.44,0,0,1.68-.96,1.44-7.93-.26-6.73,1.66,2.16,1.66,2.16Z"
                fill="#ccac8d"
              />
              <path
                d="M65.26,80.84c.4,0,.72-.32.72-.72s-.32-.72-.72-.72-.72.32-.72.72.32.72.72.72Z"
                fill="#442823"
              />
              <path
                d="M60.45,85.89c.4,0,.72-.32.72-.72s-.32-.72-.72-.72-.72.32-.72.72.32.72.72.72Z"
                fill="#442823"
              />
              <path
                d="M59.01,80.84c.4,0,.72-.32.72-.72s-.32-.72-.72-.72-.72.32-.72.72.32.72.72.72Z"
                fill="#442823"
              />
              <path
                d="M84.98,80.84c.4,0,.72-.32.72-.72s-.32-.72-.72-.72-.72.32-.72.72.32.72.72.72Z"
                fill="#442823"
              />
              <path
                d="M89.55,85.89c.4,0,.72-.32.72-.72s-.32-.72-.72-.72-.72.32-.72.72.32.72.72.72Z"
                fill="#442823"
              />
              <path
                d="M90.99,80.84c.4,0,.72-.32.72-.72s-.32-.72-.72-.72-.72.32-.72.72.32.72.72.72Z"
                fill="#442823"
              />
            </g>
          </g>
        </symbol>

        <symbol id="symb-sass" viewBox="0 0 150 150">
          <defs>
            <clipPath id="sass-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g clipPath="url(#sass-clippath)">
            <path
              d="M49.75,91.76c-2.38,1.49-5.97,3.9-8.74,6.52-4.56,4.3-5.51,10.27-3.11,11.66,2.22,1.29,7.41-.24,11.13-4.3,3.9-4.25,5.51-9.65,3.85-15.77-.2.12-.39.23-.57.34h0s-.25.15-.25.15c-.97.58-1.76,1.06-2.3,1.38M116.64,89.83c-1.35,2.93-1.42,3.87-1.01,4.17,1.96-.7,5.19-2.4,5.22-6.94,0-.68-.15-1.41-.39-2.17-2.09,1.85-3.3,3.79-3.83,4.94ZM137.64,80.97c-5.23-.61-9.31.12-12.47,1.44.59,1.53,1.04,3.11,1.1,4.72.15,3.51-2.27,6.11-4.79,7.97-1.47,1.08-3.04,1.8-4.35,2.24-1.05.44-2.45.9-3.44.7-2.19-.44-3.35-2.39-1.86-6.67.8-2.32,3.12-5.85,6.86-8.89-.85-1.75-1.8-3.54-2.29-5.19-.96-3.24-1.24-5.2-1.24-5.2,0,0-3.08,6.39-7.06,12.2-.23.34-.46.67-.69,1,.78,1.82,1.4,3.74,1.48,5.67.15,3.51-1.37,6.17-3.9,8.02-1.37,1.01-2.82,1.7-4.07,2.15-.8.35-2.43.92-4.74,1.08-1.27.09-2.48,0-3.16-.51-.94-.71-1.05-1.58-.56-2.77.41-1.01,3.47-4.51,6.04-7.57.68-.82,1.35-1.66,1.99-2.51v-.03s.45-.6,1.21-1.65c-.94-2.02-2.13-4.13-2.69-6.03-.95-3.24-1.24-5.2-1.24-5.2,0,0-3.12,8.01-6.38,14.41-2.52,4.95-4.2,7.96-4.96,9.27v.05s-.12.19-.32.49l-.15.24v-.02c-.85,1.25-2.75,3.69-4.63,3.69-5.17,0-3.27-10.51-3.27-10.51,0,0-1.51,3.89-3.22,7.23-1.39,2.72-2.65,5.03-5.42,5.03-.8,0-2.06-.02-3.11-1.02-2.38-2.26-4.19-7.99-3.84-12.43.3-3.78.89-6.39,1.68-8.57-1.59.87-3.17,1.76-4.73,2.67l-2.57,1.51.08.15c2.13,4.11,2.69,13.12-1.94,20.03-4.63,6.92-13.26,11.13-21.66,8.79-2.71-.76-6.81-6.36-3.27-14.18,3.12-6.9,15.57-13.42,18.86-15.04l.9-.5c-6.54-5.73-22.89-13.45-25.18-25.32-.65-3.34.92-11.33,10.73-20.51,8.25-7.72,19.73-13.64,30.33-17.41,17.81-6.33,36.63-2.6,39.52,8.76,2.85,11.17-6.84,24.53-19.25,29.33-11.08,4.29-20.24,3.61-24,2.37-4.28-1.41-6.79-4.23-7.4-5.82-.24-.62-.65-1.67,0-2.03.4-.22.56-.17,1.64,1.02,1.02,1.13,5.13,4.15,12.93,3.28,20.48-2.3,32.81-18.22,28.92-26.78-2.73-6-18.51-8.7-38.23,1.13-24.07,12-25.38,21.89-25.58,25.65-.56,10.34,12.75,15.77,19.95,23.46l.28.3c1.35-.74,2.77-1.53,4.17-2.3,2.88-1.58,5.77-3.16,8.65-4.74,2.54-3.68,7.68-7.75,11.39-7.75,5.94,0,3.9,8.53,3.9,8.53,0,0,.12-.39.28-.39.17,0,.82-1.12,2.66-.46,1.89.69,1.46,2.01,1.47,2.15.02.26-2.23,7.85-3.16,12.72-.45,2.32-.19,4.01-.06,4.01.18,0,.56-.59.91-1.23v-.02s.25-.48.69-1.34l.09-.18h0c.73-1.43,1.42-2.88,2.09-4.35,1.65-3.63,7.94-17.66,8.47-19.21.53-1.55.81-3.16,1.07-3.84.26-.69,2.48-1.21,5.08-1.19,2.6.02,2.86,1.13,2.88,1.36.02.23-1.24,3.31-1.52,5.48-.29,2.18-.01,3.26.23,5.09.15,1.19.9,2.71,1.78,4.43,2.69-4.4,7.42-12.81,7.87-15.16.31-1.61.81-3.16,1.07-3.84.26-.69,2.48-1.21,5.08-1.19s2.86,1.13,2.88,1.36c.02.23-1.24,3.31-1.52,5.48-.29,2.17-.01,3.26.23,5.09.2,1.56,1.41,3.66,2.61,6.05,3.27-1.61,7.12-2.69,11.63-2.72,1.87-.01,4.03.18,5.15.53v-35.95c0-2.54-1.3-4.87-3.5-6.14L78.39,1.06c-1.07-.62-2.29-.95-3.54-.95s-2.46.33-3.54.95L12.84,34.94c-2.19,1.27-3.37,3.61-3.37,6.14v67.82c0,2.53,1.18,4.87,3.37,6.14l58.57,33.9c1.07.62,2.28.95,3.52.95s2.45-.33,3.52-.95l58.6-33.9c2.19-1.27,3.47-3.61,3.47-6.14v-27.41c-.74-.22-1.83-.39-2.89-.52ZM74.55,77.42c-1.26,1.41-3.4,5.04-4.4,8.08-1.99,6.04-1.13,12.17.28,12.54,1.65.43,4.35-7.64,5.65-10.8.81-1.98,3.97-10.75,3.27-11.92-.54-.92-2.77-.18-4.8,2.09ZM97.36,97.77s-.4.38-.23.48c.23.14.74-.04,1.28-.33,1.55-.98,5.03-3.41,5.04-7.01,0-.11,0-.21-.01-.32-.72.94-1.45,1.88-2.19,2.8-1.1,1.36-3.89,4.37-3.89,4.37Z"
              fill="#8cc84b"
            />
          </g>
        </symbol>

        <symbol id="symb-react" viewBox="0 0 150 150">
          <defs>
            <clipPath id="react-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="React">
            <g clipPath="url(#react-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#242938"
                />
                <path
                  d="M75,86.1c6.04,0,10.93-4.89,10.93-10.93s-4.89-10.93-10.93-10.93-10.93,4.89-10.93,10.93,4.89,10.93,10.93,10.93Z"
                  fill="#00d8ff"
                />
                <path
                  d="M75,52.95c14.68,0,28.31,2.11,38.59,5.65,12.39,4.26,20,10.73,20,16.58s-8.07,12.97-21.37,17.37c-10.06,3.33-23.29,5.07-37.22,5.07s-27.81-1.63-37.98-5.11c-12.87-4.4-20.62-11.35-20.62-17.34s7.27-12.22,19.48-16.48c10.32-3.6,24.29-5.75,39.11-5.75h0Z"
                  fill="none"
                  stroke="#00d8ff"
                  strokeWidth="5.14"
                />
                <path
                  d="M55.65,64.12c7.33-12.71,15.97-23.47,24.17-30.61,9.88-8.6,19.29-11.97,24.36-9.04,5.28,3.05,7.2,13.47,4.37,27.19-2.14,10.38-7.24,22.71-14.2,34.78-7.14,12.37-15.31,23.28-23.4,30.35-10.24,8.95-20.13,12.19-25.32,9.2-5.03-2.9-6.95-12.4-4.54-25.11,2.04-10.74,7.15-23.91,14.56-36.75h0Z"
                  fill="none"
                  stroke="#00d8ff"
                  strokeWidth="5.14"
                />
                <path
                  d="M55.67,86.47c-7.35-12.7-12.36-25.56-14.45-36.23-2.52-12.86-.74-22.69,4.33-25.62,5.28-3.06,15.26.49,25.74,9.79,7.92,7.03,16.06,17.61,23.04,29.67,7.16,12.36,12.52,24.89,14.61,35.43,2.64,13.34.5,23.53-4.67,26.53-5.02,2.91-14.22-.17-24.02-8.61-8.28-7.13-17.14-18.14-24.57-30.97Z"
                  fill="none"
                  stroke="#00d8ff"
                  strokeWidth="5.14"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-ts" viewBox="0 0 150 150">
          <defs>
            <clipPath id="ts-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="Typescript">
            <g clipPath="url(#ts-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#007acc"
                />
                <path
                  d="M33.17,75.5l-.05,6.14h19.52v55.48h13.81v-55.48h19.52v-6.02c0-3.33-.07-6.12-.17-6.19-.07-.09-11.95-.14-26.36-.12l-26.21.07-.07,6.12ZM121.04,69.2c3.81.95,6.71,2.64,9.38,5.4,1.38,1.48,3.43,4.17,3.59,4.81.05.19-6.48,4.57-10.43,7.02-.14.1-.72-.52-1.36-1.48-1.93-2.81-3.95-4.02-7.05-4.24-4.55-.31-7.48,2.07-7.45,6.05,0,1.17.17,1.86.64,2.81,1,2.07,2.86,3.31,8.69,5.83,10.74,4.62,15.33,7.67,18.19,12,3.19,4.83,3.9,12.55,1.74,18.29-2.38,6.24-8.29,10.48-16.6,11.88-2.57.45-8.67.38-11.43-.12-6.02-1.07-11.74-4.05-15.26-7.95-1.38-1.52-4.07-5.5-3.9-5.79.07-.09.69-.47,1.38-.88.67-.38,3.19-1.83,5.57-3.21l4.31-2.5.9,1.33c1.26,1.93,4.02,4.57,5.69,5.45,4.79,2.52,11.36,2.17,14.6-.74,1.38-1.26,1.95-2.57,1.95-4.5,0-1.74-.21-2.5-1.12-3.81-1.17-1.67-3.55-3.07-10.31-6-7.74-3.33-11.07-5.4-14.12-8.69-1.76-1.9-3.43-4.95-4.12-7.5-.57-2.12-.71-7.43-.26-9.57,1.59-7.48,7.24-12.69,15.38-14.24,2.64-.5,8.79-.31,11.38.33Z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-angular" viewBox="0 0 150 150">
          <defs>
            <clipPath id="angular-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="Angular">
            <g clipPath="url(#angular-clippath)">
              <g>
                <path
                  d="M75,0L5.17,24.9l10.65,92.33,59.18,32.77,59.17-32.77,10.65-92.33L75,0Z"
                  fill="#dd0031"
                />
                <path
                  d="M75,0v16.65-.08,133.42l59.17-32.77,10.65-92.33L75,0Z"
                  fill="#c3002f"
                />
                <path
                  d="M75,16.58L31.35,114.45h16.28l8.77-21.9h37.05l8.77,21.9h16.27L75,16.58ZM87.75,79.05h-25.5l12.75-30.67,12.75,30.67Z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-node" viewBox="0 0 150 150">
          <defs>
            <clipPath id="node-clippath">
              <rect
                x="0"
                y="0"
                width="150"
                height="150"
                rx="34.71"
                ry="34.71"
                fill="none"
              />
            </clipPath>
            <linearGradient
              id="linear-gradient"
              x1="63.07"
              y1="-197.27"
              x2="51.77"
              y2="-220.18"
              gradientTransform="translate(0 -138.33) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#3f873f" />
              <stop offset=".33" stopColor="#3f8b3d" />
              <stop offset=".64" stopColor="#3e9638" />
              <stop offset=".93" stopColor="#3da92e" />
              <stop offset="1" stopColor="#3dae2b" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-2"
              x1="56.09"
              y1="-209.25"
              x2="87.62"
              y2="-186.09"
              gradientTransform="translate(0 -138.33) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".14" stopColor="#3f873f" />
              <stop offset=".4" stopColor="#52a044" />
              <stop offset=".71" stopColor="#64b749" />
              <stop offset=".91" stopColor="#6abf4b" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-3"
              x1="43.67"
              y1="-207.58"
              x2="72.3"
              y2="-207.58"
              gradientTransform="translate(0 -138.33) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset=".09" stopColor="#6abf4b" />
              <stop offset=".29" stopColor="#64b749" />
              <stop offset=".6" stopColor="#52a044" />
              <stop offset=".86" stopColor="#3f873f" />
            </linearGradient>
          </defs>
          <g id="Node">
            <g clipPath="url(#node-clippath)">
              <g>
                <rect width="150" height="150" />
                <g>
                  <path
                    d="M126.1,66.12c-.05,0-.1.02-.15.04l-2.38,1.39s-.08.07-.11.11c-.03.05-.04.1-.04.15v2.78c0,.12.06.21.14.27l2.38,1.39s.09.04.15.04.1-.02.15-.04l2.38-1.39s.08-.07.11-.11c.03-.05.04-.1.04-.15v-2.78c0-.05-.01-.11-.04-.15-.03-.05-.06-.09-.11-.11l-2.38-1.39s-.09-.05-.15-.05ZM74.21,82.76c-.43,0-.87.11-1.23.31l-11.73,6.83c-.38.22-.69.54-.9.91-.22.38-.33.81-.33,1.24v13.63c0,.89.47,1.72,1.23,2.16l3.09,1.77c1.5.74,2.03.74,2.7.74,2.2,0,3.47-1.36,3.47-3.7v-13.45c0-.09-.04-.18-.1-.25-.07-.07-.16-.1-.25-.11h-1.5c-.09,0-.18.04-.25.11-.07.07-.1.16-.11.25v13.45c0,1.04-1.09,2.07-2.82,1.19l-3.2-1.86c-.12-.06-.18-.21-.18-.33v-13.64c0-.12.06-.26.18-.32l11.73-6.8c.09-.06.24-.06.35,0l11.73,6.8c.12.06.17.18.17.33v13.63c0,.15-.06.27-.17.33l-11.73,6.83c-.09.06-.24.06-.35,0l-3-1.81c-.09-.06-.21-.09-.29-.03-.82.47-.97.53-1.76.8-.18.06-.47.18.12.5l3.91,2.34c.38.21.79.32,1.23.32s.88-.12,1.23-.26l11.73-6.83c.38-.22.69-.54.9-.92.22-.38.33-.81.33-1.24v-13.63c0-.89-.47-1.71-1.23-2.16l-11.73-6.83c-.38-.21-.8-.31-1.23-.31ZM92.52,88.98c-.6,0-1.18.24-1.6.67-.42.43-.66,1.01-.66,1.61,0,.6.24,1.18.66,1.61.42.43,1,.67,1.6.67,1.24,0,2.26-1.03,2.26-2.28,0-.6-.24-1.18-.67-1.6-.42-.43-1-.67-1.6-.68ZM92.49,89.37c.25,0,.5.04.73.14.23.09.44.23.62.41.18.18.32.39.42.62.1.23.15.48.14.73,0,1.04-.85,1.92-1.91,1.92s-1.88-.86-1.88-1.92.88-1.89,1.88-1.89ZM91.67,89.99v2.6h.5v-1.03h.44c.18,0,.23.06.26.21,0,.03.09.68.09.8h.53c-.06-.12-.09-.47-.12-.68-.03-.32-.06-.56-.41-.59.18-.06.47-.15.47-.62,0-.68-.59-.68-.88-.68h-.88ZM92.11,90.4h.41c.15,0,.38,0,.38.35,0,.12-.06.36-.38.36h-.41v-.71ZM77.41,92.44c-3.35,0-5.35,1.42-5.35,3.82,0,2.57,2,3.28,5.2,3.61,3.85.39,4.14.95,4.14,1.72,0,1.33-1.06,1.89-3.53,1.89-3.12,0-3.79-.77-4.03-2.34,0-.18-.14-.29-.32-.29h-1.53c-.09,0-.18.04-.25.11-.07.07-.1.16-.1.25,0,2.01,1.06,4.38,6.2,4.38,3.7,0,5.85-1.48,5.85-4.08s-1.71-3.22-5.32-3.7c-3.65-.47-4.03-.74-4.03-1.6,0-.71.32-1.66,3.03-1.66,2.41,0,3.32.53,3.67,2.16.02.07.06.14.12.19.06.05.13.07.21.08h1.56c.09,0,.18-.06.24-.12.05-.08.08-.17.09-.27-.23-2.84-2.09-4.14-5.85-4.14Z"
                    fill="#5fa04e"
                  />
                  <path
                    d="M97.42,35.05c-.12,0-.25.03-.36.09-.11.07-.21.16-.27.27-.07.11-.1.24-.11.37v19.22c0,.18-.09.36-.27.47-.08.04-.17.07-.26.07s-.18-.02-.26-.07l-3.11-1.8c-.23-.13-.49-.2-.75-.2s-.52.07-.75.2l-12.46,7.25c-.23.13-.42.32-.56.55-.13.23-.21.49-.21.75v14.46c0,.53.29,1.04.76,1.3l12.46,7.25c.23.13.49.2.75.2s.52-.07.75-.2l12.46-7.25c.47-.27.77-.77.77-1.3v-36.05c0-.56-.29-1.07-.77-1.33l-7.43-4.17c-.12-.06-.25-.09-.38-.09ZM23.9,53.09c-.23,0-.47.09-.67.2l-12.46,7.22c-.23.13-.43.33-.56.56-.13.23-.2.5-.2.77l.03,19.4c0,.27.15.53.38.65.11.07.24.11.37.11s.26-.04.37-.11l7.41-4.26c.47-.27.76-.77.76-1.3v-9.08c0-.53.29-1.04.77-1.3l3.14-1.83c.23-.15.5-.21.76-.21s.53.06.74.21l3.14,1.83c.47.27.76.77.76,1.3v9.08c0,.53.29,1.04.76,1.3l7.35,4.26c.11.07.25.11.38.11s.27-.04.38-.11c.12-.06.21-.16.28-.27.07-.11.1-.25.1-.38v-19.4c0-.53-.29-1.04-.77-1.3l-12.43-7.25c-.21-.11-.44-.18-.67-.2h-.12ZM126.14,53.31c-.26,0-.51.07-.75.2l-12.46,7.24c-.47.27-.76.77-.76,1.3v14.46c0,.53.29,1.04.76,1.3l12.37,7.1c.22.13.48.2.73.2s.51-.07.73-.2l7.5-4.2c.12-.06.21-.16.28-.27.07-.11.1-.25.1-.38,0-.13-.03-.26-.1-.38-.07-.11-.16-.21-.28-.27l-12.52-7.25c-.11-.07-.21-.16-.28-.28-.07-.11-.1-.24-.11-.38v-4.53c0-.13.03-.26.1-.38.07-.11.16-.21.28-.27l3.91-2.25c.11-.07.25-.11.38-.11s.27.04.38.11l3.91,2.25c.11.07.21.16.28.28.07.11.1.24.11.38v3.55c0,.27.15.53.38.65.11.07.25.11.38.11s.27-.04.38-.11l7.41-4.35c.23-.13.41-.32.54-.55.13-.23.2-.49.19-.75v-3.52c0-.53-.29-1.03-.74-1.3l-12.37-7.21c-.23-.13-.49-.2-.75-.2h0ZM92.02,64.11c.07,0,.13.02.19.05l4.26,2.48c.12.06.18.21.18.32v4.97c0,.15-.06.27-.18.33l-4.26,2.48c-.06.03-.13.04-.19.04s-.13-.02-.19-.04l-4.26-2.48c-.12-.06-.18-.21-.18-.33v-4.97c0-.15.06-.27.18-.32l4.26-2.48c.06-.03.12-.05.19-.05Z"
                    fill="#fff"
                  />
                  <path
                    d="M58.73,53.56c-.23-.13-.49-.2-.75-.2s-.52.07-.75.2l-12.37,7.19c-.23.13-.41.32-.54.55-.13.23-.2.49-.19.75v14.4c0,.53.29,1.04.74,1.3l12.37,7.19c.23.13.49.2.75.2s.52-.07.75-.2l12.37-7.19c.47-.27.74-.77.74-1.3v-14.4c0-.53-.29-1.04-.74-1.3l-12.37-7.19Z"
                    fill="url(#linear-gradient)"
                  />
                  <path
                    d="M71.13,60.75l-12.43-7.19c-.12-.06-.25-.11-.38-.15l-13.93,23.98c.12.15.26.27.41.36l12.43,7.19c.35.21.76.27,1.15.15l13.08-24.07c-.09-.11-.2-.2-.32-.27Z"
                    fill="url(#linear-gradient-2)"
                  />
                  <path
                    d="M71.13,77.76c.35-.21.62-.56.74-.95l-13.61-23.42c-.35-.06-.73-.03-1.06.18l-12.34,7.16,13.31,24.43c.18-.03.38-.09.56-.18l12.4-7.22Z"
                    fill="url(#linear-gradient-3)"
                  />
                </g>
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-vite" viewBox="0 0 150 150">
          <defs>
            <clipPath id="vite-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
            <linearGradient
              id="linear-gradient"
              x1="45.63"
              y1="-149.63"
              x2="114.06"
              y2="-242.55"
              gradientTransform="translate(0 -146.03) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#41d1ff" />
              <stop offset="1" stopColor="#bd34fe" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-2"
              x1="77.9"
              y1="-163.75"
              x2="90.28"
              y2="-248.66"
              gradientTransform="translate(0 -146.03) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#ffea83" />
              <stop offset=".08" stopColor="#ffdd35" />
              <stop offset="1" stopColor="#ffa800" />
            </linearGradient>
          </defs>
          <g id="Vite">
            <g clipPath="url(#vite-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#242938"
                />
                <path
                  d="M133.06,33.75l-54.98,98.31c-1.14,2.03-4.05,2.04-5.2.02L16.81,33.76c-1.26-2.2.63-4.87,3.12-4.42l55.04,9.84c.35.06.71.06,1.06,0l53.89-9.82c2.49-.45,4.38,2.19,3.14,4.4Z"
                  fill="url(#linear-gradient)"
                />
                <path
                  d="M101.18,16.44l-40.69,7.97c-.33.06-.62.23-.84.48-.22.25-.35.56-.37.89l-2.5,42.27c-.01.23.03.46.12.68.09.21.23.4.41.55.18.15.39.26.61.31.23.05.46.06.69,0l11.33-2.61c1.06-.24,2.02.69,1.8,1.75l-3.37,16.48c-.23,1.11.82,2.06,1.9,1.73l7-2.13c1.08-.33,2.13.62,1.9,1.73l-5.35,25.89c-.33,1.62,1.82,2.5,2.72,1.11l.6-.93,33.15-66.16c.56-1.11-.4-2.37-1.62-2.14l-11.66,2.25c-1.1.21-2.03-.81-1.72-1.88l7.61-26.38c.31-1.07-.63-2.09-1.72-1.88Z"
                  fill="url(#linear-gradient-2)"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-php" viewBox="0 0 150 150">
          <defs>
            <clipPath id="php-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="PHP">
            <g clipPath="url(#php-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#fff"
                />
                <path
                  d="M28.8,58.74h16.65c4.89.04,8.43,1.45,10.62,4.22,2.19,2.77,2.92,6.56,2.17,11.37-.29,2.19-.93,4.35-1.93,6.46-.95,2.11-2.28,4.02-3.98,5.71-2.07,2.15-4.29,3.52-6.65,4.1-2.36.58-4.8.87-7.33.87h-7.45l-2.36,11.8h-8.63l8.88-44.53ZM36.07,65.82l-3.73,18.63c.25.04.5.06.75.06h.87c3.98.04,7.29-.35,9.94-1.18,2.65-.87,4.43-3.89,5.34-9.07.75-4.35,0-6.85-2.24-7.52-2.19-.66-4.95-.97-8.26-.93-.5.04-.97.06-1.43.06h-1.3l.06-.06ZM68.08,46.88h8.57l-2.42,11.86h7.7c4.22.08,7.37.95,9.44,2.61,2.11,1.66,2.73,4.8,1.86,9.44l-4.16,20.68h-8.7l3.98-19.75c.41-2.07.29-3.54-.37-4.41-.66-.87-2.09-1.3-4.29-1.3l-6.89-.06-5.09,25.53h-8.57l8.94-44.59ZM102.44,58.74h16.65c4.89.04,8.43,1.45,10.62,4.22,2.19,2.77,2.92,6.56,2.17,11.37-.29,2.19-.93,4.35-1.93,6.46-.95,2.11-2.28,4.02-3.98,5.71-2.07,2.15-4.29,3.52-6.65,4.1-2.36.58-4.8.87-7.33.87h-7.45l-2.36,11.8h-8.63l8.88-44.53ZM109.7,65.82l-3.73,18.63c.25.04.5.06.75.06h.87c3.98.04,7.29-.35,9.94-1.18,2.65-.87,4.43-3.89,5.34-9.07.75-4.35,0-6.85-2.24-7.52-2.19-.66-4.95-.97-8.26-.93-.5.04-.97.06-1.43.06h-1.3l.06-.06Z"
                  fill="#242938"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-py" viewBox="0 0 150 150">
          <defs>
            <clipPath id="py-clippath">
              <rect
                width="150"
                height="150"
                rx="34.71"
                ry="34.71"
                fill="none"
              />
            </clipPath>
          </defs>
          <g id="Python">
            <g clipPath="url(#py-clippath)">
              <g>
                <rect width="150" height="150" rx="15.51" ry="15.51" />
                <g>
                  <path
                    d="M124.6,40.89c18.07,3,19.06,44.46,9.09,55.63-3.32,3.72-8.5,5.08-13.25,5.86h-49.43s0,7.49,0,7.49h30.75v19.53c0,2.98-5.24,6.15-7.75,7.21-11.76,5.01-43.88,6.69-46.2-10.61-1.29-9.67-.08-23.98-.08-34,0-5.22,4.7-9.44,4.7-9.44,12.6-9.85,36.3,1.29,48.42-8.09,2.48-1.92,8.39-9.5,8.39-12.39v-21.19c4.71.54,10.89-.74,15.37,0ZM86.17,117.56c-3.53,3.73,1.22,11.61,6.9,8.15,7.12-4.33-1.47-13.89-6.9-8.15Z"
                    fill="#febf08"
                  />
                  <path
                    d="M47.72,23.02c.34-5.29,5.03-8.99,10.14-10.64,11.28-3.64,41.32-5.22,43.83,10.69.88,5.58.93,31.81,0,37.3-2.89,17.3-36.06,8.64-47.1,11.91-5.06,1.5-14.36,11.39-14.36,16.39v20.36h-15.37c-1.14,0-6.88-3.46-7.95-4.52-8.91-8.82-8.69-38.23-2.31-48.95,2.27-3.81,8.26-8.03,12.75-8.03h51.11v-7.48h-30.75c.26-5.64-.36-11.4,0-17.04ZM64,32.88c4.2-4.2-4.5-12.34-8.35-7.74-4.91,5.85,3.64,12.45,8.35,7.74Z"
                    fill="#0477bd"
                  />
                </g>
              </g>
            </g>
          </g>
        </symbol>
        <symbol id="symb-wp" viewBox="0 0 150 150">
          <defs>
            <clipPath id="wp-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="WP">
            <g clipPath="url(#wp-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#0073aa"
                />
                <path
                  d="M24.73,75c0,19.9,11.56,37.09,28.33,45.24L29.09,54.54c-2.87,6.44-4.36,13.41-4.35,20.46ZM108.93,72.46c0-6.21-2.23-10.51-4.14-13.86-2.55-4.14-4.94-7.65-4.94-11.79,0-4.62,3.5-8.92,8.44-8.92.22,0,.43.03.65.04-8.94-8.19-20.86-13.19-33.94-13.19-17.56,0-33.01,9.01-42,22.66,1.18.04,2.29.06,3.23.06,5.26,0,13.4-.64,13.4-.64,2.71-.16,3.03,3.82.32,4.14,0,0-2.72.32-5.75.48l18.3,54.44,11-32.99-7.83-21.46c-2.71-.16-5.27-.48-5.27-.48-2.71-.16-2.39-4.3.32-4.14,0,0,8.3.64,13.24.64,5.26,0,13.4-.64,13.4-.64,2.71-.16,3.03,3.82.32,4.14,0,0-2.73.32-5.75.48l18.16,54.03,5.01-16.75c2.17-6.95,3.83-11.95,3.83-16.25Z"
                  fill="#fff"
                />
                <path
                  d="M75.88,79.39l-15.08,43.82c4.61,1.36,9.39,2.05,14.2,2.05,5.68,0,11.33-.96,16.69-2.85-.14-.22-.26-.45-.36-.69l-15.45-42.33ZM119.1,50.88c.23,1.71.34,3.44.34,5.17,0,5.1-.95,10.83-3.82,18l-15.35,44.39c14.94-8.71,24.99-24.9,24.99-43.45,0-8.74-2.23-16.96-6.16-24.12Z"
                  fill="#fff"
                />
                <path
                  d="M75,16.41c-32.31,0-58.59,26.28-58.59,58.59s26.29,58.59,58.59,58.59,58.6-26.28,58.6-58.59c0-32.31-26.29-58.59-58.6-58.59ZM75,130.9c-30.83,0-55.91-25.08-55.91-55.91s25.08-55.9,55.91-55.9,55.9,25.08,55.9,55.9-25.08,55.91-55.9,55.91Z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-vsc" viewBox="0 0 150 150">
          <defs>
            <clipPath id="vsc-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="VS_Code" data-name="VS Code">
            <g clipPath="url(#vsc-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#fff"
                />
                <path
                  d="M19.76,58.72s-2.77-2,.55-4.67l7.76-6.94s2.22-2.33,4.57-.3l71.57,54.19v25.98s-.03,4.08-5.27,3.63L19.76,58.72Z"
                  fill="#2489ca"
                />
                <path
                  d="M38.2,75.46l-18.45,16.77s-1.9,1.41,0,3.93l8.56,7.79s2.03,2.19,5.04-.3l19.56-14.83-14.71-13.36Z"
                  fill="#1070b3"
                />
                <path
                  d="M70.59,75.6l33.83-25.83-.22-25.85s-1.45-5.64-6.27-2.7l-45.02,40.98,17.67,13.41Z"
                  fill="#0877b9"
                />
                <path
                  d="M98.93,130.65c1.97,2.01,4.35,1.35,4.35,1.35l26.37-12.99c3.37-2.3,2.9-5.15,2.9-5.15V36.27c0-3.41-3.49-4.59-3.49-4.59l-22.85-11.02c-4.99-3.09-8.26.55-8.26.55,0,0,4.21-3.03,6.26,2.7v102.58c0,.7-.15,1.39-.45,2.02-.6,1.21-1.91,2.35-5.04,1.87l.22.24Z"
                  fill="#3c99d4"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-gh" viewBox="0 0 150.21 150.37">
          <defs>
            <clipPath id="gh-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="GH">
            <g clipPath="url(#gh-clippath)">
              <g>
                <path
                  d="M115,0H35.21C15.76,0,0,15.76,0,35.21v79.8c0,19.44,15.76,35.21,35.21,35.21h16.56s-7.61-2.92-38.06-35.21c-5.58-181.48,143.61-94.2,125.85-34.82,4.2,31.43-41.1,70.03-41.1,70.03h16.56c19.44,0,35.21-15.76,35.21-35.21V35.21c0-19.44-15.76-35.21-35.21-35.21Z"
                  fill="#fff"
                />
                <path
                  d="M75.04,4.08c-17.82,0-35.05,6.33-48.62,17.87C12.84,33.49,3.82,49.48.97,67.07c-2.85,17.59.65,35.61,9.88,50.85,9.23,15.24,23.58,26.7,40.48,32.32,3.75.69,5.13-1.63,5.13-3.61,0-1.79-.08-7.7-.1-13.96-20.87,4.54-25.27-8.85-25.27-8.85-3.41-8.67-8.33-10.98-8.33-10.98-6.81-4.66.52-4.56.52-4.56,7.53.52,11.49,7.72,11.49,7.72,6.69,11.47,17.55,8.15,21.83,6.23.67-4.85,2.62-8.16,4.76-10.03-16.66-1.89-34.17-8.33-34.17-37.07,0-8.18,2.93-14.88,7.73-20.13-.78-1.89-3.35-9.52.72-19.85,0,0,6.3-2.02,20.63,7.69,6.12-1.66,12.43-2.51,18.77-2.52,6.38.03,12.8.86,18.79,2.52,14.32-9.7,20.61-7.69,20.61-7.69,4.08,10.33,1.52,17.96.74,19.85,4.81,5.25,7.72,11.94,7.72,20.13,0,28.81-17.55,35.15-34.25,37,2.69,2.33,5.09,6.89,5.09,13.89,0,10.03-.08,18.11-.08,20.58,0,2,1.35,4.33,5.16,3.6,16.9-5.63,31.25-17.09,40.47-32.33,9.22-15.24,12.72-33.27,9.86-50.85-2.86-17.58-11.88-33.58-25.46-45.11-13.57-11.54-30.81-17.87-48.63-17.85v.02Z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-git" viewBox="0 0 150.01 150">
          <defs>
            <clipPath id="git-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="Git">
            <g clipPath="url(#gitclippath)">
              <path
                d="M147.17,68.32L81.68,2.83c-.9-.9-1.96-1.61-3.13-2.09C77.37.25,76.11,0,74.85,0s-2.52.25-3.7.74c-1.17.49-2.24,1.2-3.13,2.09l-13.59,13.59,17.25,17.25c2.03-.69,4.22-.8,6.32-.31,2.09.49,4.01,1.56,5.52,3.08,1.52,1.53,2.57,3.45,3.05,5.54.48,2.1.35,4.28-.35,6.31l16.62,16.63c2.46-.87,5.14-.87,7.6,0,2.46.86,4.56,2.53,5.94,4.74,1.38,2.21,1.97,4.83,1.67,7.42-.3,2.59-1.48,5-3.33,6.83-1.88,1.88-4.35,3.06-7,3.32-2.65.26-5.3-.4-7.51-1.87-2.21-1.47-3.85-3.67-4.62-6.22-.77-2.54-.64-5.28.37-7.74l-15.52-15.51v40.81c1.11.53,2.12,1.25,3.04,2.17,1.75,1.74,2.88,4,3.25,6.44.36,2.44-.07,4.93-1.24,7.11-1.16,2.18-3,3.92-5.23,4.97-2.23,1.05-4.74,1.36-7.16.87-2.42-.49-4.62-1.74-6.27-3.57-1.65-1.83-2.67-4.15-2.91-6.6-.24-2.46.32-4.92,1.6-7.04,1.27-2.11,3.2-3.76,5.48-4.7v-41.18c-1.4-.58-2.68-1.42-3.75-2.49-1.07-1.07-1.93-2.34-2.51-3.74-.58-1.4-.88-2.9-.87-4.42,0-1.52.31-3.02.89-4.42l-16.99-17.01L2.84,68.02c-.9.9-1.61,1.96-2.09,3.13-.49,1.17-.74,2.43-.74,3.7s.25,2.52.74,3.7c.49,1.17,1.2,2.24,2.09,3.13l65.49,65.49c.9.9,1.96,1.61,3.13,2.09,1.17.49,2.43.74,3.7.74s2.52-.25,3.7-.74c1.17-.49,2.24-1.2,3.13-2.09l65.18-65.18c.9-.9,1.61-1.96,2.1-3.14.49-1.17.74-2.43.74-3.7s-.25-2.53-.74-3.7c-.49-1.17-1.2-2.24-2.1-3.13"
                fill="#fff"
              />
            </g>
          </g>
        </symbol>

        <symbol id="symb-cli" viewBox="0 0 150 150">
          <path
            id="CLI"
            d="M0,25c0-6.63,2.63-12.99,7.32-17.68C12.01,2.63,18.37,0,25,0h100c6.63,0,12.99,2.63,17.68,7.32,4.69,4.69,7.32,11.05,7.32,17.68v100c0,6.63-2.63,12.99-7.32,17.68-4.69,4.69-11.05,7.32-17.68,7.32H25c-6.63,0-12.99-2.63-17.68-7.32-4.69-4.69-7.32-11.05-7.32-17.68V25ZM27.75,49.63c-1.76,1.76-2.74,4.14-2.74,6.63s.99,4.87,2.74,6.63l12.12,12.12-12.12,12.12c-.92.86-1.66,1.89-2.17,3.04-.51,1.15-.79,2.39-.81,3.65-.02,1.26.21,2.51.68,3.68.47,1.17,1.17,2.23,2.06,3.12.89.89,1.95,1.59,3.12,2.06,1.17.47,2.42.7,3.68.68,1.26-.02,2.5-.3,3.65-.81,1.15-.51,2.18-1.25,3.04-2.17l18.75-18.75c1.76-1.76,2.74-4.14,2.74-6.63s-.99-4.87-2.74-6.63l-18.75-18.75c-1.76-1.76-4.14-2.74-6.62-2.74s-4.87.99-6.62,2.74ZM84.37,81.25c-2.49,0-4.87.99-6.63,2.75-1.76,1.76-2.75,4.14-2.75,6.63s.99,4.87,2.75,6.63c1.76,1.76,4.14,2.75,6.63,2.75h31.25c2.49,0,4.87-.99,6.63-2.75,1.76-1.76,2.75-4.14,2.75-6.63s-.99-4.87-2.75-6.63c-1.76-1.76-4.14-2.75-6.63-2.75h-31.25Z"
            fill="#fff"
            fillRule="evenodd"
          />
        </symbol>

        <symbol id="symb-postgres" viewBox="0 0 150 150.04">
          <defs>
            <clipPath id="postgres-clippath">
              <rect y=".04" width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="Postgres">
            <g clipPath="url(#postgres-clippath)">
              <g>
                <path
                  id="Postgres-2"
                  data-name="Postgres"
                  d="M111.31,109.42c.96-8,.67-9.17,6.63-7.88l1.51.13c4.58.21,10.58-.74,14.1-2.37,7.58-3.52,12.07-9.39,4.6-7.85-17.05,3.52-18.22-2.26-18.22-2.26,18-26.71,25.53-60.62,19.03-68.92-17.72-22.64-48.38-11.93-48.9-11.66l-.16.03c-3.37-.7-7.14-1.12-11.37-1.19-7.71-.13-13.57,2.02-18.01,5.39,0,0-54.71-22.54-52.16,28.35.54,10.82,15.52,81.91,33.38,60.44,6.53-7.85,12.84-14.49,12.84-14.49,3.13,2.08,6.88,3.14,10.82,2.76l.3-.26c-.1.97-.05,1.93.12,3.06-4.6,5.14-3.25,6.04-12.45,7.94-9.31,1.92-3.84,5.33-.27,6.22,4.33,1.08,14.34,2.62,21.11-6.85l-.27,1.08c1.8,1.44,1.68,10.38,1.94,16.76.26,6.38.68,12.34,1.98,15.85,1.3,3.51,2.84,12.56,14.93,9.97,10.1-2.16,17.83-5.28,18.53-34.26Z"
                />
                <path d="M88.84,150c-5.35,0-8.83-2.07-10.94-4.06-3.19-3.01-4.46-6.89-5.21-9.21l-.33-.97c-1.52-4.11-2.04-10.03-2.35-17.65-.05-1.14-.08-2.32-.11-3.57-.03-.91-.06-2.06-.1-3.26-1.93.92-3.97,1.57-6.08,1.92-3.77.64-7.82.44-12.05-.62-2.98-.75-6.08-2.29-7.84-4.68-5.15,4.51-10.05,3.9-12.73,3-4.72-1.57-8.94-5.99-12.91-13.51-2.83-5.36-5.56-12.34-8.13-20.74-4.47-14.64-7.31-30.07-7.56-35.13C1.7,25.66,5.97,14.32,15.18,7.82c14.52-10.26,36.53-4.23,44.55-1.49,5.39-3.25,11.73-4.83,18.9-4.72,3.85.06,7.51.4,10.92,1.01C93.09,1.51,100.1-.1,108.13,0c14.79.18,27.05,5.94,35.44,16.67,5.99,7.65,3.03,23.73.73,32.63-3.23,12.52-8.9,25.84-15.86,37.43,1.89.01,4.63-.21,8.52-1.02,7.68-1.59,9.93,2.53,10.54,4.38,2.44,7.4-8.18,12.99-11.49,14.53-4.24,1.97-11.16,3.17-16.83,2.91l-.25-.02-1.49-.13-.15,1.24-.14,1.21c-.38,14.69-2.48,24-6.8,30.14-4.53,6.45-10.82,8.25-16.36,9.44-1.89.4-3.61.58-5.17.58ZM77.59,96.53c3.45,2.76,3.75,7.96,4.02,17.67.03,1.21.07,2.36.11,3.43.13,3.24.43,10.84,1.62,14.05.17.45.32.91.48,1.4,1.33,4.06,1.99,6.1,7.72,4.87,4.81-1.03,7.29-1.96,9.22-4.71,2.81-4.01,4.39-12.07,4.68-23.97l5.86.14-5.82-.7.17-1.45c.56-4.79.96-8.24,4.16-10.53,2.57-1.83,5.49-1.66,7.82-1.24-2.56-1.93-3.27-4.2-3.46-5.13l-.49-2.41,1.37-2.04c7.91-11.73,14.42-26.15,17.89-39.55,3.56-13.78,2.47-21.09,1.39-22.47-14.36-18.35-39.26-10.77-41.86-9.91l-.44.24-2.2.41-1.13-.23c-3.11-.65-6.57-1-10.28-1.06-5.82-.1-10.52,1.28-14.37,4.2l-2.67,2.03-3.1-1.28c-6.63-2.71-26.09-8.16-36.36-.88-5.7,4.04-8.3,11.95-7.72,23.52.19,3.82,2.79,18.28,7.07,32.3,5.91,19.38,11.29,25.81,13.53,26.56.39.13,1.41-.66,2.42-1.87,4.22-5.05,8.58-9.98,13.09-14.78l3.39-3.57,4.1,2.72c1.65,1.1,3.48,1.72,5.35,1.84l9.78-8.34-1.42,14.46c-.03.32-.05.77.08,1.59l.43,2.74-1.85,2.07-.21.24,5.37,2.48,2.25-2.82Z" />
                <path
                  d="M138.15,91.46c-17.05,3.52-18.22-2.26-18.22-2.26,18-26.71,25.53-60.62,19.03-68.92-17.72-22.64-48.39-11.93-48.9-11.65l-.17.03c-3.37-.7-7.14-1.12-11.38-1.18-7.71-.13-13.57,2.02-18.01,5.39,0,0-54.71-22.54-52.17,28.35.54,10.83,15.52,81.91,33.38,60.44,6.53-7.85,12.84-14.49,12.84-14.49,3.13,2.08,6.88,3.14,10.81,2.76l.31-.26c-.1.97-.05,1.93.12,3.06-4.6,5.14-3.25,6.04-12.45,7.94-9.31,1.92-3.84,5.33-.27,6.22,4.33,1.08,14.34,2.61,21.1-6.85l-.27,1.08c1.8,1.44,3.07,9.39,2.86,16.6-.21,7.21-.36,12.15,1.07,16.02,1.42,3.86,2.84,12.56,14.93,9.97,10.1-2.17,15.34-7.78,16.07-17.13.52-6.66,1.69-5.67,1.76-11.62l.94-2.82c1.08-9.02.17-11.93,6.4-10.58l1.51.13c4.58.21,10.58-.74,14.1-2.37,7.58-3.52,12.07-9.39,4.6-7.85Z"
                  fill="#336791"
                />
                <path
                  d="M89.45,146.39c-10.08,0-13.27-7.98-14.58-11.25-1.91-4.78-2.33-23.35-1.9-38.57,0-.26.06-.51.17-.74.1-.23.25-.45.44-.62.19-.18.41-.31.65-.41.24-.09.5-.13.75-.13.26,0,.51.06.74.17.23.1.45.25.62.44.18.19.31.41.41.65.09.24.13.49.13.75-.49,17.56.21,33.47,1.62,37.01,2.21,5.52,5.56,10.35,15.03,8.32,8.99-1.93,12.36-5.34,13.86-14.03,1.15-6.67,3.43-25.65,3.71-29.4.02-.26.09-.51.2-.73.12-.23.27-.43.47-.6.19-.17.42-.29.66-.37.24-.08.5-.11.76-.09.52.04,1,.28,1.33.67.34.39.51.9.47,1.42-.29,3.9-2.56,22.84-3.75,29.77-1.77,10.27-6.35,14.93-16.89,17.19-1.79.38-3.42.55-4.9.56ZM34.8,107.4c-.88,0-1.76-.15-2.59-.43-6.55-2.18-12.78-12.85-18.53-31.69-4.38-14.35-7.15-29.32-7.4-34.19-.72-14.43,2.99-24.64,11.04-30.34,15.93-11.28,42.72-.54,43.85-.08.48.2.86.57,1.06,1.05.2.48.2,1.02,0,1.5-.2.48-.57.86-1.05,1.06-.48.2-1.02.2-1.5,0-.26-.11-25.95-10.4-40.12-.35-6.88,4.88-10.04,13.95-9.39,26.95.2,4.1,2.8,18.71,7.23,33.24,5.14,16.83,10.98,27.44,16.03,29.13.79.26,3.21,1.07,6.66-3.08,4.02-4.83,8.2-9.54,12.52-14.11.36-.36.85-.57,1.36-.57.51,0,1,.19,1.37.54.37.35.58.84.6,1.35.02.51-.17,1.01-.51,1.38-.06.06-5.93,6.2-12.34,13.91-3.03,3.65-5.94,4.72-8.31,4.72ZM119.81,90.94c-.35,0-.7-.1-1.01-.28-.3-.18-.55-.44-.72-.76-.17-.31-.24-.66-.23-1.02.02-.35.13-.7.33-.99,18.2-27,24.59-59.63,19.12-66.62-6.89-8.8-16.61-13.39-28.9-13.66-9.1-.2-16.33,2.13-17.52,2.53l-.3.12c-1.19.37-2.1-.28-2.45-1.04-.2-.44-.23-.93-.08-1.39.14-.46.45-.85.86-1.09.06-.03.24-.11.53-.22,2.01-.74,9.35-2.94,18.45-2.84,13.6.14,24.83,5.39,32.49,15.17,3.62,4.63,3.63,15.29.02,29.25-3.68,14.23-10.59,29.53-18.97,41.97-.37.56-.99.86-1.62.86ZM120.74,103.44c-3.11,0-5.89-.44-7.56-1.44-1.71-1.03-2.04-2.42-2.08-3.16-.47-8.22,4.07-9.65,6.38-10.3-.32-.49-.78-1.06-1.25-1.65-1.35-1.68-3.19-3.99-4.62-7.44-.22-.54-.92-1.79-1.73-3.24-4.38-7.86-13.5-24.21-7.64-32.58,2.71-3.88,8.11-5.4,16.06-4.55-2.34-7.13-13.48-29.43-39.92-29.86-7.95-.13-14.47,2.31-19.37,7.26-10.97,11.08-10.57,31.13-10.57,31.33,0,.26-.04.51-.13.75-.09.24-.23.46-.41.64-.18.19-.39.34-.62.44s-.49.16-.74.17c-.26,0-.51-.04-.75-.13-.24-.09-.46-.23-.64-.41-.19-.18-.34-.39-.44-.62-.1-.23-.16-.49-.17-.74-.02-.89-.43-21.93,11.7-34.18,5.68-5.73,13.15-8.56,22.21-8.42,16.91.28,27.8,8.88,33.95,16.04,6.71,7.81,10,16.42,10.27,19.29.2,2.14-1.33,2.56-1.64,2.63l-.71.02c-7.8-1.25-12.81-.38-14.88,2.58-4.46,6.37,4.17,21.84,7.85,28.44.94,1.68,1.62,2.9,1.93,3.65,1.21,2.93,2.79,4.9,4.05,6.49,1.12,1.39,2.08,2.6,2.43,4.02.16.28,2.44,3.65,15.94.86,3.39-.7,5.42-.1,6.04,1.78,1.22,3.69-5.63,8-9.42,9.76-3.4,1.58-8.82,2.58-13.51,2.58ZM114.99,98.52c.43.43,2.57,1.18,7.01.99,3.95-.17,8.11-1.03,10.61-2.19,3.19-1.48,5.33-3.14,6.43-4.28l-.61.11c-8.64,1.78-14.74,1.55-18.15-.71-.23-.15-.45-.32-.66-.49-.37.15-.71.24-.96.31-1.93.54-3.94,1.1-3.67,6.25ZM59.2,109.44c-2.15,0-4.4-.29-6.71-.87-2.39-.6-6.42-2.4-6.35-5.35.07-3.31,4.89-4.31,6.7-4.68,6.56-1.35,6.98-1.89,9.03-4.49.6-.76,1.34-1.7,2.35-2.83,1.5-1.68,3.15-2.54,4.89-2.54,1.21,0,2.2.41,2.86.68,2.09.87,3.84,2.96,4.55,5.47.65,2.26.34,4.44-.87,6.13-3.96,5.55-9.66,8.49-16.46,8.49ZM50.36,103.38c.59.46,1.77,1.06,3.08,1.39,2,.5,3.93.75,5.76.75,5.57,0,10.04-2.3,13.28-6.85.68-.95.47-2.15.29-2.78-.38-1.33-1.32-2.53-2.29-2.93-.53-.22-.96-.38-1.37-.38-.22,0-.87,0-1.98,1.24-.76.86-1.49,1.74-2.2,2.65-2.55,3.24-3.72,4.34-11.31,5.9-1.85.38-2.8.77-3.27,1.02ZM65.38,94.37c-.47,0-.92-.17-1.27-.47-.35-.3-.59-.72-.66-1.19-.05-.32-.08-.65-.1-.98-4.98-.09-9.78-2.23-13.42-6.03-4.61-4.81-6.71-11.47-5.75-18.28,1.03-7.39.65-13.92.44-17.42-.06-.97-.1-1.68-.1-2.17,0-.62.02-2.26,5.5-5.04,1.95-.99,5.86-2.71,10.13-3.15,7.07-.73,11.74,2.42,13.13,8.87,3.77,17.42.3,25.13-2.23,30.75-.47,1.05-.92,2.04-1.27,3l-.31.84c-1.34,3.59-2.5,6.69-2.14,9,.04.25.03.51-.03.76-.06.25-.17.48-.32.69-.15.21-.34.38-.56.51-.22.13-.46.22-.72.26l-.3.02ZM48.44,48.38l.08,1.39c.22,3.64.62,10.42-.47,18.19-.78,5.61.93,11.09,4.71,15.03,2.98,3.11,6.91,4.83,10.95,4.83h.08c.45-1.9,1.2-3.91,2.01-6.08l.31-.84c.4-1.08.87-2.13,1.37-3.24,2.44-5.42,5.47-12.16,1.98-28.32-.69-3.2-2.37-5.05-5.13-5.67-5.67-1.25-14.11,3.01-15.89,4.7ZM60.23,47.55c-.1.69,1.26,2.53,3.04,2.78,1.77.25,3.29-1.19,3.39-1.88.1-.69-1.26-1.45-3.04-1.7-1.78-.25-3.29.11-3.39.8ZM63.68,51.01l-.5-.03c-1.1-.15-2.22-.85-2.98-1.86-.27-.36-.71-1.04-.62-1.66.12-.9,1.22-1.44,2.94-1.44.38,0,.78.03,1.18.08.94.13,1.81.4,2.45.76,1.11.62,1.2,1.32,1.15,1.67-.14,1-1.72,2.47-3.62,2.47ZM60.88,47.67c.06.43,1.11,1.83,2.48,2.02l.32.02c1.27,0,2.22-1,2.33-1.32-.12-.22-.93-.78-2.48-.99-.33-.05-.67-.07-1.01-.07-.99,0-1.52.22-1.65.35ZM114.27,46.14c.1.69-1.26,2.53-3.04,2.78-1.78.25-3.29-1.19-3.39-1.88-.09-.69,1.27-1.45,3.04-1.7,1.78-.25,3.29.11,3.39.8ZM110.82,49.28c-1.71,0-3.19-1.33-3.31-2.19-.14-1.04,1.57-1.82,3.32-2.07.39-.05.77-.08,1.14-.08,1.52,0,2.52.44,2.62,1.16.06.46-.29,1.18-.9,1.83-.41.42-1.26,1.16-2.42,1.32l-.45.03ZM111.97,45.59c-.34,0-.69.02-1.05.07-1.76.25-2.82.95-2.77,1.33.06.42,1.18,1.63,2.66,1.63l.36-.03c.96-.13,1.69-.76,2.03-1.13.54-.57.76-1.11.73-1.29-.03-.24-.69-.6-1.98-.6ZM116.83,85.8c-.35,0-.7-.1-1.01-.28-.3-.18-.55-.44-.72-.76-.17-.31-.24-.66-.23-1.02.02-.35.13-.7.33-.99,4.16-6.21,3.4-12.55,2.66-18.68-.31-2.61-.64-5.31-.55-7.9.09-2.67.43-4.86.75-6.99.39-2.52.75-4.9.6-7.73-.01-.26.02-.51.11-.75.09-.24.22-.46.39-.66.17-.19.38-.35.61-.46s.48-.17.74-.19c.26-.01.51.02.75.11.24.09.46.22.66.39.39.35.62.83.65,1.35.17,3.23-.24,5.92-.64,8.53-.31,2.01-.63,4.09-.71,6.52-.07,2.29.22,4.73.53,7.31.78,6.52,1.67,13.9-3.29,21.32-.18.27-.42.49-.71.64-.28.15-.6.23-.92.23Z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-supabase" viewBox="0 0 150 150">
          <defs>
            <clipPath id="supabase-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
            <mask
              id="supabase-mask"
              x="18.75"
              y="16.41"
              width="113.04"
              height="117.19"
              maskUnits="userSpaceOnUse"
            >
              <g id="mask0_207_56" data-name="mask0 207 56">
                <path d="M18.75,16.41h113.04v117.19H18.75V16.41Z" fill="#fff" />
              </g>
            </mask>
            <linearGradient
              id="linear-gradient"
              x1="70.96"
              y1="144.93"
              x2="112.64"
              y2="127.45"
              gradientTransform="translate(0 227.33) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#249361" />
              <stop offset="1" stopColor="#3ecf8e" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-2"
              x1="72.95"
              y1="188.09"
              x2="91.96"
              y2="152.31"
              gradientTransform="translate(0 227.33) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#000" />
              <stop offset="1" stopColor="#000" stopOpacity="0" />
            </linearGradient>
          </defs>
          <g id="Supabase">
            <g clipPath="url(#supabase-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#f4f2ed"
                />
                <g mask="url(#supabase-mask)">
                  <g>
                    <path
                      d="M84.82,130.78c-2.97,3.73-8.98,1.69-9.05-3.08l-1.04-69.74h46.9c8.49,0,13.23,9.81,7.95,16.46l-44.75,56.36Z"
                      fill="url(#linear-gradient)"
                    />
                    <path
                      d="M84.82,130.78c-2.97,3.73-8.98,1.69-9.05-3.08l-1.04-69.74h46.9c8.49,0,13.23,9.81,7.95,16.46l-44.75,56.36Z"
                      fill="url(#linear-gradient-2)"
                      fillOpacity=".2"
                    />
                    <path
                      d="M65.75,18.55c2.97-3.74,8.98-1.69,9.05,3.08l.46,69.74H28.95c-8.49,0-13.23-9.81-7.95-16.46l44.75-56.36Z"
                      fill="#3ecf8e"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-firebase" viewBox="0 0 150 150">
          <defs>
            <clipPath id="firebase-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="Firebase">
            <g clipPath="url(#firebase-clippath)">
              <g>
                <path
                  d="M20.48,121.03L38.94,2.89c.11-.71.44-1.36.94-1.87.5-.51,1.15-.85,1.86-.97.7-.12,1.43-.01,2.07.3.64.31,1.17.82,1.51,1.45l19.09,35.61,7.61-14.49c.29-.55.72-1.01,1.26-1.33.53-.32,1.14-.49,1.76-.49s1.23.17,1.76.49c.53.32.97.78,1.26,1.33l51.53,98.1H20.48Z"
                  fill="#ffa000"
                />
                <path
                  d="M84.26,75.01l-19.86-37.61L20.48,121.03l63.78-46.02Z"
                  fill="#f57c00"
                />
                <path
                  d="M129.58,121.03l-14.14-87.51c-.1-.62-.38-1.19-.79-1.67-.41-.47-.94-.82-1.54-1.01-.6-.19-1.23-.21-1.84-.06-.61.15-1.16.46-1.61.9L20.48,121.03l49.35,27.68c1.52.85,3.24,1.3,4.99,1.3s3.46-.45,4.99-1.3l49.78-27.68Z"
                  fill="#ffca28"
                />
                <path
                  d="M115.44,33.52c-.1-.62-.38-1.19-.79-1.67-.41-.47-.94-.82-1.54-1.01-.6-.19-1.23-.21-1.84-.07-.61.15-1.16.46-1.61.9l-17.7,17.75-13.92-26.5c-.29-.55-.72-1.01-1.26-1.33-.53-.32-1.14-.49-1.76-.49s-1.23.17-1.76.49c-.53.32-.97.78-1.26,1.33l-7.61,14.49L45.31,1.8c-.34-.63-.87-1.14-1.51-1.45-.64-.31-1.37-.42-2.07-.3-.7.12-1.35.46-1.86.97-.5.51-.83,1.16-.94,1.87l-18.45,118.13h-.06l.06.07.49.24L109.65,32.55c.44-.44,1-.76,1.61-.91.61-.15,1.25-.13,1.84.06.6.19,1.13.54,1.54,1.02.41.47.68,1.05.79,1.67l14.02,86.72.14-.09-14.14-87.51ZM20.64,120.87L38.94,3.73c.11-.71.44-1.36.94-1.87.5-.51,1.15-.85,1.86-.97.71-.12,1.43-.02,2.07.3.64.31,1.17.82,1.51,1.45l19.09,35.61,7.61-14.49c.29-.55.72-1.01,1.26-1.33.53-.32,1.14-.49,1.76-.49s1.23.17,1.76.49c.53.32.97.78,1.26,1.33l13.64,25.94L20.64,120.87h0Z"
                  fill="rgba(255, 255, 255, .2)"
                />
                <path
                  d="M79.8,147.87c-1.52.85-3.24,1.3-4.99,1.3s-3.46-.45-4.99-1.3l-49.24-27.6-.12.76,49.35,27.67c1.52.85,3.24,1.3,4.99,1.3s3.46-.45,4.99-1.3l49.78-27.67-.13-.78-49.65,27.63h0Z"
                  fill="#a52714"
                  isolation="isolate"
                  opacity=".2"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-mysql" viewBox="0 0 150 150">
          <defs>
            <clipPath id="mysql-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="MySQL">
            <g clipPath="url(#mysql-clippath)">
              <path
                d="M102.54,35.48c-.73,0-1.22.1-1.71.22v.08h.07c.34.63.91,1.13,1.34,1.71.34.66.63,1.34.95,2l.1-.1c.59-.42.88-1.07.88-2.08-.24-.3-.3-.61-.51-.88-.24-.42-.78-.63-1.13-.95ZM36.06,117.94h-5.78c-.17-9.21-.74-18.4-1.68-27.56h-.05l-8.81,27.56h-4.42l-8.74-27.56h-.08c-.68,9.17-1.09,18.37-1.22,27.56H0c.29-11.56,1.14-23.1,2.56-34.57h7.18l8.35,25.39h.05l8.42-25.39h6.83c1.52,12.6,2.41,24.12,2.69,34.57h-.02ZM61.16,92.43c-2.34,12.79-5.47,22.1-9.3,27.88-3.02,4.47-6.33,6.71-9.91,6.71-.95,0-2.13-.29-3.54-.88v-3.07c.71.1,1.51.17,2.42.17,1.68,0,3.03-.49,4.05-1.39,1.22-1.12,1.83-2.39,1.83-3.78,0-.98-.46-2.93-1.44-5.91l-6.32-19.73h5.69l4.54,14.75c1.03,3.37,1.47,5.69,1.27,7.03,2.51-6.64,4.25-13.92,5.23-21.78h5.48ZM138.21,117.94h-16.45v-34.57h5.54v30.32h10.91v4.25ZM117.46,118.78l-6.35-3.13c.56-.46,1.09-.98,1.59-1.56,2.71-3.15,4.05-7.86,4.05-14.06,0-11.45-4.49-17.17-13.48-17.16-4.4,0-7.83,1.44-10.3,4.35-2.69,3.17-4.05,7.86-4.05,14.04s1.2,10.52,3.59,13.38c2.2,2.54,5.49,3.83,9.91,3.83,1.64,0,3.15-.2,4.52-.61l8.28,4.83,2.27-3.9h-.03ZM96.88,111.01c-1.42-2.25-2.1-5.86-2.1-10.84,0-8.71,2.64-13.06,7.94-13.06,2.76,0,4.81,1.05,6.1,3.13,1.39,2.27,2.1,5.84,2.1,10.77,0,8.77-2.66,13.19-7.94,13.19-2.78,0-4.81-1.05-6.13-3.13l.02-.05ZM86.52,108.37c0,2.93-1.07,5.35-3.25,7.2-2.15,1.88-5.01,2.83-8.64,2.83-3.39,0-6.64-1.07-9.84-3.22l1.49-2.98c2.73,1.37,5.2,2.05,7.45,2.05,2.08,0,3.71-.46,4.88-1.37,1.17-.93,1.88-2.22,1.88-3.86,0-2.05-1.44-3.81-4.05-5.27-2.42-1.34-7.27-4.1-7.27-4.1-2.64-1.93-3.93-3.98-3.93-7.37,0-2.8.98-5.06,2.93-6.76,1.98-1.76,4.49-2.61,7.62-2.61,3.11-.03,6.16.87,8.77,2.56l-1.34,2.98c-2.09-.93-4.35-1.41-6.64-1.44-1.78,0-3.15.44-4.1,1.29-1.43,1.28-1.54,1.93-1.54,3.27,0,2.05,1.47,3.81,4.15,5.32,2.47,1.34,7.42,4.18,7.42,4.18,2.71,1.9,4.05,3.96,4.05,7.3h-.02ZM145.14,71.78c-3.35-.08-5.93.27-8.1,1.2-.61.24-1.61.24-1.71,1.03.34.34.39.88.68,1.34.51.83,1.37,1.95,2.17,2.54.88.68,1.76,1.37,2.66,1.95,1.64,1,3.47,1.59,5.08,2.59.9.59,1.83,1.34,2.73,1.95.46.32.76.88,1.34,1.07v-.12c-.3-.37-.37-.9-.66-1.34-.42-.42-.83-.78-1.25-1.2-1.22-1.62-2.69-3.05-4.35-4.22-1.34-.9-4.27-2.18-4.81-3.71l-.07-.1c.9-.08,1.98-.42,2.85-.66,1.42-.37,2.73-.3,4.2-.66.67-.17,1.34-.37,2-.59v-.37c-.76-.75-1.32-1.78-2.1-2.49-2.16-1.88-4.46-3.6-6.89-5.13-1.32-.85-2.98-1.39-4.37-2.1-.49-.24-1.34-.37-1.61-.78-.76-.93-1.2-2.12-1.73-3.22-1.23-2.38-2.37-4.81-3.42-7.28-.76-1.64-1.2-3.25-2.12-4.76-4.3-7.11-8.99-11.4-16.16-15.62-1.54-.88-3.39-1.25-5.35-1.71-1.05-.05-2.08-.12-3.13-.17-.68-.3-1.34-1.07-1.93-1.47-2.39-1.51-8.55-4.76-10.28-.46-1.13,2.73,1.66,5.4,2.64,6.76.71.98,1.61,2.05,2.12,3.13.3.73.37,1.49.66,2.25.66,1.83,1.29,3.88,2.17,5.59.46.88.95,1.8,1.54,2.59.34.46.93.66,1.05,1.42-.59.85-.63,2.1-.95,3.13-1.51,4.73-.93,10.57,1.2,14.06.68,1.05,2.27,3.35,4.4,2.47,1.88-.75,1.47-3.13,2-5.23.12-.51.05-.83.3-1.17v.1c.61,1.17,1.2,2.3,1.73,3.47,1.27,2.05,3.54,4.18,5.42,5.59,1,.75,1.78,2.05,3.03,2.51v-.12h-.1c-.27-.37-.61-.54-.95-.83-.79-.78-1.53-1.62-2.2-2.51-1.73-2.34-3.3-4.93-4.66-7.59-.66-1.32-1.26-2.66-1.81-4.03-.24-.49-.24-1.25-.66-1.49-.63.9-1.56,1.68-2,2.83-.81,1.78-.88,4-1.2,6.3-.15.05-.08,0-.15.1-1.34-.34-1.8-1.71-2.3-2.88-1.27-2.98-1.47-7.74-.39-11.16.3-.88,1.54-3.64,1.05-4.47-.27-.81-1.1-1.27-1.54-1.9-.56-.78-1.13-1.78-1.51-2.66-1-2.34-1.49-4.93-2.59-7.27-.49-1.07-1.37-2.2-2.08-3.2-.81-1.12-1.68-1.93-2.3-3.25-.22-.46-.51-1.22-.17-1.71.08-.34.24-.46.59-.56.54-.46,2.1.12,2.64.39,1.54.61,2.83,1.2,4.12,2.08.59.42,1.22,1.2,1.98,1.42h.88c1.34.3,2.83.08,4.08.46,2.22.71,4.22,1.73,6.03,2.85,5.52,3.54,10.01,8.48,13.01,14.31.51.95.73,1.83,1.2,2.83.85,2.08,1.95,4.15,2.83,6.13.88,1.98,1.71,3.98,2.98,5.62.63.88,3.13,1.34,4.27,1.78.83.39,2.12.73,2.85,1.17,1.44.88,2.85,1.88,4.2,2.85.69.46,2.76,1.51,2.88,2.34h0Z"
                fill="#fff"
              />
            </g>
          </g>
        </symbol>

        <symbol id="symb-gcloud" viewBox="0 0 150 150">
          <defs>
            <clipPath id="gcloud-clippath">
              <rect x="0" width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="Google_Cloud" data-name="Google Cloud">
            <g clipPath="url(#gcloud-clippath)">
              <g>
                <path
                  d="M96.24,48.24h.51l-.26-.26,17.93-17.93v-.38c-15.11-13.32-35.99-17.93-55.33-12.17-19.34,5.76-34.2,21.13-39.57,40.6.26-.13.64-.26,1.02-.26,6.66-4.35,14.6-6.92,22.92-6.92,2.82,0,5.51.26,8.2.77.13-.13.26-.13.38-.13,11.53-12.68,30.99-14.22,44.31-3.33h-.13Z"
                  fill="#ea4535"
                />
                <path
                  d="M131.46,57.84c-2.95-10.89-9.09-20.75-17.67-28.3l-18.31,18.19c7.68,6.28,12.17,15.75,11.91,25.61v3.2c21.64,0,21.64,32.27,0,32.27h-32.53v25.61h-.13l.13.26h32.53c18.7.13,35.22-11.91,40.73-29.59,5.51-17.67-1.28-36.88-16.65-47.26Z"
                  fill="#557ebf"
                />
                <path
                  d="M42.96,134.81h33.68v-25.87h-33.68c-2.43,0-4.74-.51-6.92-1.41l-19.47,18.7v.26c7.68,5.51,16.91,8.45,26.51,8.45l-.13-.13Z"
                  fill="#36a852"
                />
                <path
                  d="M44.5,50.28c-19.08.13-35.99,11.91-42.14,29.2-6.15,17.42,0,36.5,15.11,47.77l19.98-19.08c-11.01-4.74-13.58-18.57-5.12-26.64,8.45-8.2,22.8-5.64,27.79,4.87l19.98-19.08c-8.45-10.63-21.64-16.91-35.6-16.78v-.26Z"
                  fill="#f9bc15"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-aws" viewBox="0 0 150 150">
          <defs>
            <clipPath id="aws-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="AWS">
            <g clipPath="url(#aws-clippath)">
              <g>
                <path
                  d="M114.84,0H35.16C15.74,0,0,15.74,0,35.16v79.69c0,19.42,15.74,35.16,35.16,35.16h79.69c19.42,0,35.16-15.74,35.16-35.16V35.16c0-19.42-15.74-35.16-35.16-35.16Z"
                  fill="#f4f2ed"
                />
                <path
                  d="M49.66,65.6c0,1.43.15,2.58.42,3.43.34.95.75,1.88,1.23,2.78.19.31.27.62.27.89,0,.39-.23.77-.73,1.16l-2.43,1.62c-.35.23-.69.35-1,.35-.39,0-.77-.19-1.16-.54-.52-.56-.98-1.16-1.39-1.81-.43-.74-.83-1.5-1.2-2.27-3.01,3.55-6.78,5.32-11.33,5.32-3.24,0-5.82-.93-7.71-2.78-1.89-1.85-2.85-4.32-2.85-7.4,0-3.28,1.16-5.94,3.51-7.94,2.35-2,5.47-3.01,9.44-3.01,1.31,0,2.66.12,4.09.31,1.43.19,2.89.5,4.43.85v-2.81c0-2.93-.62-4.97-1.81-6.17-1.23-1.2-3.32-1.77-6.28-1.77-1.35,0-2.74.15-4.16.5-1.43.35-2.81.77-4.16,1.31-.44.2-.89.36-1.35.5-.27.08-.46.12-.62.12-.54,0-.81-.39-.81-1.2v-1.89c0-.62.08-1.08.27-1.35.19-.27.54-.54,1.08-.81,1.35-.69,2.97-1.27,4.86-1.73,1.89-.5,3.89-.73,6.01-.73,4.59,0,7.94,1.04,10.1,3.12,2.12,2.08,3.2,5.24,3.2,9.48v12.49h.08ZM34.01,71.46c1.27,0,2.58-.23,3.97-.69,1.39-.46,2.62-1.31,3.66-2.47.62-.73,1.08-1.54,1.31-2.47.23-.93.39-2.04.39-3.35v-1.62c-1.17-.28-2.35-.5-3.55-.66-1.2-.15-2.41-.23-3.62-.23-2.58,0-4.47.5-5.74,1.54-1.27,1.04-1.89,2.51-1.89,4.43,0,1.81.46,3.16,1.43,4.09.93.96,2.28,1.43,4.05,1.43ZM64.96,75.62c-.69,0-1.16-.12-1.46-.39-.31-.23-.58-.77-.81-1.5l-9.06-29.8c-.23-.77-.35-1.27-.35-1.54,0-.62.31-.96.93-.96h3.78c.73,0,1.23.12,1.5.39.31.23.54.77.77,1.5l6.48,25.52,6.01-25.52c.19-.77.42-1.27.73-1.5.31-.23.85-.38,1.54-.38h3.08c.73,0,1.23.12,1.54.38.31.23.58.77.73,1.5l6.09,25.83,6.67-25.83c.23-.77.5-1.27.77-1.5.31-.23.81-.38,1.5-.38h3.58c.62,0,.96.31.96.96,0,.19-.04.39-.08.62-.04.23-.12.54-.27.96l-9.29,29.8c-.23.77-.5,1.27-.81,1.5-.31.23-.81.39-1.46.39h-3.32c-.73,0-1.23-.12-1.54-.39-.31-.27-.58-.77-.73-1.54l-5.98-24.86-5.94,24.82c-.19.77-.42,1.27-.73,1.54-.31.27-.85.39-1.54.39h-3.32ZM114.49,76.67c-2,0-4.01-.23-5.94-.69-1.93-.46-3.43-.96-4.43-1.54-.62-.35-1.04-.73-1.19-1.08-.15-.34-.23-.71-.23-1.08v-1.97c0-.81.31-1.2.89-1.2.23,0,.46.04.69.12.23.08.58.23.96.39,1.36.6,2.78,1.05,4.24,1.35,1.51.31,3.05.46,4.59.46,2.43,0,4.32-.42,5.63-1.27,1.31-.85,2-2.08,2-3.66,0-1.08-.35-1.97-1.04-2.7-.69-.73-2-1.39-3.89-2l-5.59-1.73c-2.81-.89-4.9-2.2-6.17-3.93-1.27-1.7-1.93-3.59-1.93-5.59,0-1.62.35-3.05,1.04-4.28.69-1.23,1.62-2.31,2.77-3.16,1.16-.89,2.47-1.54,4.01-2.01,1.54-.46,3.16-.66,4.86-.66.85,0,1.73.04,2.58.15.89.12,1.7.27,2.51.42.77.19,1.5.39,2.2.62.69.23,1.23.46,1.62.69.54.31.93.62,1.16.96.23.31.35.73.35,1.27v1.81c0,.81-.31,1.23-.89,1.23-.31,0-.81-.15-1.46-.46-2.2-1-4.66-1.5-7.4-1.5-2.2,0-3.93.35-5.13,1.08-1.19.73-1.81,1.85-1.81,3.43,0,1.08.39,2,1.16,2.74.77.73,2.2,1.46,4.24,2.12l5.47,1.73c2.78.89,4.78,2.12,5.97,3.7,1.19,1.58,1.77,3.39,1.77,5.4,0,1.66-.35,3.16-1,4.47-.69,1.31-1.62,2.47-2.81,3.39-1.19.96-2.62,1.66-4.28,2.16-1.74.54-3.55.81-5.51.81Z"
                  fill="#252f3e"
                />
                <path
                  d="M121.78,95.4c-12.68,9.37-31.11,14.34-46.95,14.34-22.2,0-42.21-8.21-57.32-21.86-1.2-1.08-.12-2.54,1.31-1.7,16.34,9.48,36.51,15.23,57.36,15.23,14.07,0,29.53-2.93,43.75-8.94,2.12-.96,3.93,1.39,1.85,2.93Z"
                  fill="#f90"
                  fillRule="evenodd"
                />
                <path
                  d="M127.06,89.39c-1.62-2.08-10.72-1-14.84-.5-1.23.15-1.43-.93-.31-1.73,7.25-5.09,19.16-3.62,20.55-1.93,1.39,1.74-.39,13.65-7.17,19.35-1.04.89-2.04.42-1.58-.73,1.54-3.82,4.97-12.41,3.35-14.46Z"
                  fill="#f90"
                  fillRule="evenodd"
                />
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-cloudflare-workers" viewBox="0 0 150 150">
          <defs>
            <clipPath id="cloudflare-workers-clippath">
              <rect x="0" width="150" height="150" fill="none" />
            </clipPath>
            <linearGradient
              id="linear-gradient"
              x1="69.88"
              y1="-493.4"
              x2="44.2"
              y2="-451.14"
              gradientTransform="translate(0 -427.15) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#eb6f07" />
              <stop offset="1" stopColor="#fab743" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-2"
              x1="65.5"
              y1="-494.49"
              x2="52.2"
              y2="-480.68"
              gradientTransform="translate(0 -427.15) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#d96504" />
              <stop offset="1" stopColor="#d96504" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-3"
              x1="53.83"
              y1="-447.68"
              x2="60.98"
              y2="-458.96"
              gradientTransform="translate(0 -427.15) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#eb6f07" />
              <stop offset="1" stopColor="#eb720a" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-4"
              x1="98.24"
              y1="-501.02"
              x2="74.79"
              y2="-452.55"
              gradientTransform="translate(0 -427.15) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#ee6f05" />
              <stop offset="1" stopColor="#fab743" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-5"
              x1="61.55"
              y1="-478.34"
              x2="98.64"
              y2="-468.9"
              gradientTransform="translate(0 -427.15) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#d96504" stopOpacity=".8" />
              <stop offset=".5" stopColor="#d96504" stopOpacity=".2" />
              <stop offset="1" stopColor="#d96504" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-6"
              x1="81.27"
              y1="-500.97"
              x2="57.89"
              y2="-452.73"
              gradientTransform="translate(0 -427.15) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#ffa95f" />
              <stop offset="1" stopColor="#ffebc8" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-7"
              x1="70.42"
              y1="-472.91"
              x2="90.11"
              y2="-476.02"
              gradientTransform="translate(0 -427.15) scale(1 -1)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#fff" stopOpacity=".5" />
              <stop offset="1" stopColor="#fff" stopOpacity=".1" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-8"
              x1="51.54"
              y1="-474.74"
              x2="75.92"
              y2="-471.13"
              xlinkHref="#linear-gradient-7"
            />
          </defs>
          <g id="Cloudflare_Workers" data-name="Cloudflare Workers">
            <g clipPath="url(#cloudflare-workers-clippath)">
              <g>
                <path
                  d="M9.2,133.73L.65,108.64h5.91l5.19,16.87,5.58-16.94h4.7l5.63,16.94,5.19-16.87h5.76l-8.55,25.08h-4.79l-5.65-16.29-5.65,16.29h-4.79ZM49.11,134.05c-5.94,0-10.33-4.4-10.33-9.9v-.08c0-5.52,4.45-9.98,10.42-9.98s10.35,4.4,10.35,9.9v.08c0,5.52-4.45,9.98-10.42,9.98h-.02ZM49.19,129.35c3.13,0,5-2.38,5-5.19v-.08c0-2.81-2.04-5.27-5.06-5.27s-5,2.38-5,5.19v.08c0,2.81,2.04,5.27,5.06,5.27ZM63.43,133.56v-19.11h5.42v3.86c1.1-2.64,2.89-4.35,6.1-4.22v5.68h-.29c-3.6,0-5.81,2.17-5.81,6.73v7.06h-5.42ZM78.36,133.56v-25.96h5.42v13.84l6.33-6.94h6.49l-7.25,7.51,7.51,11.55h-6.2l-5-7.79-1.88,2v5.79h-5.42ZM107.67,134.05c-5.76,0-10.01-4.06-10.01-9.9v-.08c0-5.47,3.89-9.98,9.47-9.98,6.41,0,9.35,4.96,9.35,10.4,0,.44-.03.94-.06,1.44h-13.35c.54,2.47,2.25,3.75,4.69,3.75,1.82,0,3.15-.57,4.66-1.96l3.1,2.76c-.94,1.16-2.14,2.09-3.5,2.71-1.36.62-2.85.91-4.34.86ZM103.02,122.53h8.11c-.32-2.43-1.74-4.06-4.01-4.06s-3.68,1.61-4.1,4.06ZM120.54,133.56v-19.11h5.42v3.86c1.1-2.64,2.89-4.35,6.1-4.22v5.68h-.29c-3.6,0-5.81,2.17-5.81,6.73v7.06h-5.42ZM142.08,134.05c-2.99-.02-5.89-1.04-8.24-2.89l2.32-3.57c1.74,1.35,3.85,2.14,6.05,2.27,1.59,0,2.3-.57,2.3-1.43v-.07c0-1.18-1.87-1.57-3.98-2.22-2.69-.78-5.73-2.03-5.73-5.74v-.08c0-3.89,3.15-6.07,7.01-6.07,2.43,0,5.09.81,7.17,2.22l-2.08,3.73c-1.56-1.01-3.34-1.62-5.19-1.78-1.33,0-2.01.58-2.01,1.33v.08c0,1.07,1.82,1.56,3.89,2.27,2.69.91,5.81,2.19,5.81,5.68v.08c0,4.25-3.18,6.18-7.33,6.18Z"
                  fill="#b3b3b3"
                />
                <path
                  d="M20.05,100.08h5.84v2.89h-9.22v-11.97h3.38v9.08ZM42.46,96.93v.03c-.01.84-.19,1.68-.53,2.45-.34.77-.82,1.47-1.44,2.05-.61.58-1.33,1.04-2.12,1.34-.79.3-1.63.44-2.47.41-3.73,0-6.52-2.76-6.52-6.2v-.05c.01-.83.19-1.65.52-2.41.33-.76.81-1.45,1.4-2.03s1.3-1.03,2.07-1.34c.77-.31,1.6-.46,2.43-.45h.13c3.75,0,6.52,2.76,6.52,6.2ZM39.03,96.96c0-1.72-1.25-3.21-3.11-3.21s-3.08,1.46-3.08,3.2v.05c0,1.72,1.27,3.21,3.1,3.21s3.1-1.46,3.1-3.2v-.05h0ZM54.45,97.74c0,1.65-.88,2.45-2.22,2.45s-2.24-.81-2.24-2.55v-6.65h-3.41v6.72h-.02c0,3.76,2.17,5.47,5.63,5.47s5.68-1.69,5.68-5.53v-6.65h-3.42v6.75ZM74.55,96.9v.05c0,3.46-2.56,6.02-6.93,6.02h-4.61v-11.97h4.67c4.33,0,6.86,2.45,6.86,5.9ZM71.11,96.95c0-1.91-1.35-3.03-3.36-3.03h-1.36v6.12h1.36c2.01,0,3.36-1.1,3.36-3.03v-.05ZM79.43,102.95h3.36v-4.27h5.74v-2.76h-5.74v-2.03h6.34v-2.9h-9.7v11.96ZM97.18,90.99h-3.36v11.97h9.25v-2.89h-5.89v-9.08ZM115.05,90.91l5.19,12.05h-3.62l-.89-2.13h-4.67l-.86,2.13h-3.52l5.14-12.05h3.23ZM114.78,98.24l-1.33-3.39-1.36,3.41h2.69v-.02ZM132.82,98.81l2.9,4.18h-3.89l-2.43-3.63h-1.48v3.63h-3.37v-12h5.73c1.86,0,3.13.47,3.96,1.3.71.68,1.09,1.61,1.09,2.81v.03c0,1.83-1.01,3.05-2.5,3.68ZM131.93,95.28c0-.94-.68-1.41-1.82-1.41h-2.21v2.87h2.24c1.14,0,1.78-.55,1.78-1.41v-.05ZM143.51,100.14v-1.91h5.81v-2.63h-5.81v-1.78h6.41v-2.82h-9.75v11.97h9.83v-2.82h-6.49ZM6.54,93.75c1.38,0,2.43.81,2.87,1.98h3.54c-.31-1.45-1.12-2.74-2.29-3.65-1.17-.91-2.62-1.38-4.1-1.33-.84-.03-1.68.11-2.47.41s-1.51.75-2.12,1.34c-.61.58-1.1,1.28-1.44,2.05-.34.77-.52,1.61-.53,2.45v.03c0,3.44,2.76,6.2,6.51,6.2,1.45.04,2.86-.41,4.02-1.28,1.16-.87,1.98-2.11,2.34-3.51l-3.54-.02c-.49,1.04-1.48,1.78-2.77,1.78-1.83,0-3.08-1.51-3.08-3.21v-.05c0-1.74,1.22-3.2,3.07-3.2Z"
                  fill="#fff"
                />
                <g>
                  <path
                    d="M58.57,16.82l7.95,14.34-7.3,13.14c-.35.63-.53,1.33-.53,2.05s.18,1.42.53,2.05l7.3,13.17-7.95,14.34c-1.5-.74-2.74-1.91-3.57-3.36l-12.65-21.98c-.74-1.28-1.13-2.74-1.13-4.22s.39-2.93,1.13-4.22l12.65-21.98c.83-1.44,2.08-2.6,3.57-3.34Z"
                    fill="url(#linear-gradient)"
                  />
                  <path
                    d="M59.21,44.32c-.35.63-.53,1.33-.53,2.04s.18,1.42.53,2.04l7.3,13.17-7.95,14.34c-1.5-.74-2.74-1.91-3.57-3.36l-12.66-21.98c-1.01-1.74,4.62-3.81,16.87-6.25v-.02Z"
                    fill="url(#linear-gradient-2)"
                    isolation="isolate"
                    opacity=".7"
                  />
                  <path
                    d="M59.38,18.26l7.14,12.9-1.18,2.06-6.3-10.66c-1.82-2.97-4.59-1.43-8.06,4.58l.52-.89,3.5-6.08c.83-1.44,2.06-2.6,3.54-3.34l.83,1.44h.02Z"
                    fill="url(#linear-gradient-3)"
                    isolation="isolate"
                    opacity=".5"
                  />
                  <path
                    d="M94.91,20.16l12.65,21.98c.74,1.28,1.13,2.74,1.13,4.22s-.39,2.94-1.13,4.22l-12.65,21.98c-.74,1.28-1.8,2.35-3.09,3.09-1.28.74-2.73,1.13-4.21,1.13h-12.65l15.74-28.37c.35-.63.53-1.33.53-2.04s-.18-1.42-.53-2.04l-15.74-28.37h12.65c1.48,0,2.93.39,4.21,1.13,1.28.74,2.35,1.8,3.09,3.09Z"
                    fill="url(#linear-gradient-4)"
                  />
                  <path
                    d="M86.96,76.68l-12.49.11,15.12-28.52c.34-.63.51-1.34.51-2.06s-.18-1.43-.51-2.06l-15.12-28.21h2.85l15.87,28.08c.38.66.57,1.41.57,2.18,0,.76-.2,1.51-.59,2.17-3.41,5.93-6.81,11.88-10.17,17.85-3.08,5.42-1.75,8.91,3.96,10.46Z"
                    fill="url(#linear-gradient-5)"
                  />
                  <path
                    d="M62.3,76.78c-1.29,0-2.57-.3-3.73-.86l15.61-28.15c.24-.43.36-.92.36-1.41s-.13-.98-.36-1.41l-15.61-28.13c1.16-.57,2.44-.87,3.73-.88h12.65l15.74,28.37c.35.63.53,1.33.53,2.04s-.18,1.42-.53,2.04l-15.74,28.37h-12.65Z"
                    fill="url(#linear-gradient-6)"
                  />
                  <path
                    d="M89.58,44.95l-16.09-29.01h1.46l15.74,28.37c.35.63.53,1.33.53,2.04s-.18,1.42-.53,2.04l-15.74,28.37h-1.46l16.09-29.01c.24-.43.36-.92.36-1.41s-.13-.98-.36-1.41Z"
                    fill="url(#linear-gradient-7)"
                    isolation="isolate"
                    opacity=".6"
                  />
                  <path
                    d="M74.17,44.95l-15.61-28.13c.49-.26,1.07-.45,1.62-.62,3.44,6.18,8.52,15.56,15.25,28.12.35.63.53,1.33.53,2.04s-.18,1.42-.53,2.04l-15.49,28.05c-.47-.13-.92-.31-1.36-.52l15.57-28.15c.24-.43.36-.92.36-1.41s-.13-.98-.36-1.41l.02-.02Z"
                    fill="url(#linear-gradient-8)"
                    isolation="isolate"
                    opacity=".6"
                  />
                </g>
              </g>
            </g>
          </g>
        </symbol>

        <symbol id="symb-openai" viewBox="0 0 150 150">
          <defs>
            <clipPath id="openai-clippath">
              <rect width="150" height="150" fill="none" />
            </clipPath>
          </defs>
          <g id="OpenAI">
            <g clipPath="url(#openai-clippath)">
              <path
                d="M139.26,61.38c1.67-5.05,2.25-10.4,1.69-15.69-.56-5.29-2.23-10.4-4.92-15-3.99-6.94-10.08-12.43-17.39-15.69-7.31-3.26-15.47-4.11-23.3-2.44-4.45-4.95-10.11-8.63-16.44-10.7-6.32-2.06-13.08-2.42-19.58-1.05-6.51,1.37-12.54,4.43-17.49,8.88-4.95,4.44-8.64,10.11-10.71,16.43-5.21,1.07-10.14,3.25-14.45,6.37-4.31,3.13-7.9,7.13-10.54,11.75-4.03,6.93-5.75,14.96-4.91,22.94.83,7.97,4.18,15.47,9.56,21.42-1.68,5.05-2.27,10.4-1.72,15.69.55,5.29,2.22,10.41,4.91,15,3.99,6.94,10.09,12.44,17.41,15.7,7.32,3.26,15.48,4.11,23.31,2.42,3.54,3.98,7.88,7.15,12.74,9.32,4.86,2.17,10.12,3.28,15.44,3.25,8.02,0,15.84-2.54,22.32-7.26,6.48-4.72,11.3-11.38,13.75-19.02,5.21-1.07,10.14-3.25,14.44-6.37,4.31-3.12,7.9-7.13,10.54-11.75,3.98-6.92,5.67-14.92,4.83-22.86-.84-7.94-4.16-15.41-9.5-21.35ZM82.88,140.19c-6.57,0-12.93-2.29-17.98-6.5l.88-.51,29.87-17.24c.74-.44,1.35-1.06,1.78-1.81s.66-1.59.67-2.45v-42.11l12.62,7.3c.06.03.12.08.16.13s.07.12.08.19v34.89c-.02,7.44-2.98,14.58-8.24,19.84-5.26,5.26-12.4,8.23-19.84,8.24ZM22.5,114.4c-3.3-5.69-4.48-12.36-3.34-18.84l.89.53,29.89,17.24c.74.43,1.58.66,2.44.66s1.7-.23,2.44-.66l36.52-21.06v14.57c0,.08-.02.15-.06.22-.04.07-.09.13-.15.17l-30.25,17.44c-6.46,3.72-14.12,4.72-21.31,2.79-7.19-1.93-13.33-6.63-17.06-13.08ZM14.62,49.35c3.32-5.72,8.56-10.09,14.79-12.33v35.48c0,.86.21,1.7.64,2.45.43.74,1.04,1.36,1.79,1.79l36.34,20.96-12.63,7.3c-.07.03-.14.05-.22.05s-.15-.02-.22-.05l-30.19-17.41c-6.45-3.73-11.15-9.87-13.08-17.06-1.93-7.19-.93-14.86,2.78-21.32v.15ZM118.36,73.44l-36.46-21.17,12.59-7.28c.07-.03.14-.05.22-.05s.15.02.22.05l30.19,17.44c4.62,2.66,8.38,6.58,10.86,11.31,2.47,4.72,3.55,10.05,3.11,15.36-.44,5.31-2.39,10.39-5.61,14.64-3.22,4.25-7.58,7.49-12.58,9.35v-35.49c-.03-.86-.28-1.69-.72-2.42-.45-.73-1.07-1.33-1.82-1.75ZM130.92,54.55l-.88-.53-29.84-17.39c-.74-.43-1.59-.66-2.45-.66s-1.71.23-2.45.66l-36.49,21.06v-14.58c0-.07,0-.15.04-.21.03-.07.08-.12.14-.17l30.19-17.42c4.63-2.66,9.92-3.95,15.25-3.72,5.33.23,10.49,1.98,14.87,5.03,4.38,3.05,7.8,7.29,9.86,12.22,2.06,4.93,2.67,10.34,1.77,15.6v.12ZM51.92,80.39l-12.63-7.27c-.06-.04-.12-.09-.16-.15-.04-.06-.07-.13-.08-.2v-34.79c.01-5.34,1.54-10.56,4.41-15.06,2.87-4.5,6.96-8.09,11.79-10.36,4.83-2.26,10.21-3.1,15.5-2.42,5.29.68,10.28,2.85,14.39,6.26l-.89.5-29.86,17.24c-.74.44-1.36,1.06-1.79,1.81-.43.75-.66,1.59-.67,2.45l-.02,42.01ZM58.78,65.61l16.26-9.37,16.29,9.37v18.74l-16.23,9.37-16.29-9.37-.03-18.74Z"
                fill="#fff"
              />
            </g>
          </g>
        </symbol>
      </defs>
    </svg>
  );
}
